<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col cols="4" lg="6">
        <!--Display Trash or Normal Table View-->
        <h2 v-show="!trash">All Hauls</h2>
        <h2 v-show="trash">All Hauls - Trash</h2>
      </b-col>

      <!--Gear Icon :data       <b-button ref="ex_csv"></b-button>       :data   = "items_csv"      @click="openExcel()"    v-b-popover.hover.top="'Export to csv'"      = "items"   ref="excel"   v-b-popover.hover.top="'Export to csv'"   @click="openExcel()"         :data   = "items" -->
      <b-col cols="8" lg="6">
        <b-btn class="pull-right ml5" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="openSelectColumns()"><i class="fa fa-cog"></i></b-btn>
        <b-btn class="pull-right ml5" v-b-popover.hover.top="'Activate/Deactivate bbl'" variant="info" @click="bbl()"><i class="fa fa-bullseye"></i></b-btn>
        <!--<download-excel
            ref="excel"
            :data   = "items_csv" 
            :fields = "json_fields"
            type    = "csv"
            :name   = "filename"
            >     
         </download-excel>  -->
        <b-button id="e_csv" ref="e_csv" class="pull-right ml5" :disabled="iscsv" v-show="activated" v-b-popover.hover.top="'Export to csv'" variant="info" @click="csv_export()"><i class="fa fa-file-excel-o"></i></b-button>           
        <b-btn class="pull-right ml5" v-b-popover.hover.top="'Create Folder'" variant="info" @click="openCreateFolder()"><i class="fa fa-folder"></i></b-btn>
        <!-- <b-btn v-if="role =='super_analyst' || role =='analyst' || role =='trucking_company_admin'" class="pull-right ml5" :pressed.sync="myToggle" v-b-popover.hover.top="'Activate/Deactivate hauls approved'" variant="info" @click="h_approved_change()"><i class="fa fa-toggle-on"></i></b-btn> -->       
      </b-col>
      
    </div>
    <div class="filters pb-2">
      <h5 v-if="progress" class="pull-right ml5" > <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i> {{load_csv }}</h5>
    </div>
    <!-- Filters block-->
    <div class="filters pb-2">
      <b-row>
        <b-col order="1" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <b-form-input v-model="filter" placeholder="Search" />
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </div>
          </div>
        </b-col>

        <b-col order="3" order-md="2" v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" sm="6" md="2" lg="2" class="my-1" title="Actived / Deleted">
          <b-dropdown class="custom_dropdown custom_dropdown_b" id="ddown1" :text="dpdt">
            <b-dropdown-item @click="trashHaul()">Active</b-dropdown-item>
            <b-dropdown-item @click="trashHaul()">Trash</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <!-- <b-col order="4" order-md="3" v-if="h_approved" sm="6"  md="2" lg="2" class="my-1">
          <b-btn @click="HaulsApproved()">Hauls Approved</b-btn>
        </b-col> -->
        <b-col order="5" order-md="4" sm="6"  md="2" lg="2" class="my-1" title="Folder">
          <b-dropdown class="custom_dropdown custom_dropdown_b" id="ddown1" :text="filters_save.folder">
            <b-dropdown-item @click="Folders('All Folders', 0)">All Folders</b-dropdown-item>
            <b-dropdown-item v-for="(folder) in folders" @click="Folders(folder.name, folder.id)">{{folder.name}}</b-dropdown-item>
            <b-dropdown-item @click="Folders('Unassigned Hauls', 0)">Unassigned Hauls</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col order="2" order-md="5" cols="4" sm="6" md="2" lg="2" class="ml-auto my-1">
          <b-button v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" class="pull-right" variant="primary" @click="showNewHaulModal()">Add Haul</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" class="my-1" title="Energy Companies" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.energy_company_name" >
            <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
            <b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f2" title="Drivers" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.driver_name">
            <b-dropdown-item @click="dFilter('All Drivers', 0)">All Drivers</b-dropdown-item>
            <b-dropdown-item v-for="driver_filter in drivers_filter" @click="dFilter(driver_filter.username, driver_filter.id)">{{driver_filter.username}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col v-if="role =='super_admin' || role =='super_analyst' || role =='analyst' || this.role =='marketing_accountant' || role =='operations_manager'" class="my-1 f4" title="Trucking Companies" sm="6" md="3" lg="2">
            <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.trucking_company_name">
              <b-dropdown-item @click="tcFilter('All Trucking Companies', 0)"><h6>All Trucking Companies</h6></b-dropdown-item>
              <b-dropdown-item v-for="trucking_company_filter in trucking_companies_filter" @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)">{{trucking_company_filter.name}}</b-dropdown-item>
            </b-dropdown>
        </b-col>
        <b-col class="my-1 f5" title="Trucks" sm="6" md="3" lg="2">
            <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.truck_name">
              <b-dropdown-item @click="tFilter('All Trucks', 0)">All Trucks</b-dropdown-item>
              <b-dropdown-item v-for="truck_filter in trucks_filter" @click="tFilter(truck_filter.truck_name, truck_filter.id)">{{truck_filter.truck_name}}</b-dropdown-item>
            </b-dropdown>
        </b-col>
        <b-col class="my-1 f6" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.load_name" title="Load Locations">
            <b-dropdown-item @click="lFilter('All Loads', 0)">All Loads</b-dropdown-item>
            <b-dropdown-item v-for="load_location_filter in load_locations_filter" @click="lFilter(load_location_filter.legal_location, load_location_filter.id)">{{load_location_filter.legal_location}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f7" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.unload_name" title="Unload Locations">
            <b-dropdown-item @click="uFilter('All Unloads', 0)">All Unloads</b-dropdown-item>
            <b-dropdown-item v-for="unload_location_filter in unload_locations_filter" @click="uFilter(unload_location_filter.legal_location, unload_location_filter.id)">{{unload_location_filter.legal_location}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col v-if="role =='super_admin' || role =='super_analyst' || role =='analyst' || this.role =='marketing_accountant' || role =='trucking_company_admin' || role =='trucking_operational_manager'" class="my-1" title="Fluid Types" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.fluid_type_name" >
            <b-dropdown-item @click="ftFilter('All Fluid Types', 0)">All Fluid Types</b-dropdown-item>
            <b-dropdown-item v-for="fluid_type_filter in fluid_types_filter" @click="ftFilter(fluid_type_filter.name, fluid_type_filter.id)">{{fluid_type_filter.name}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f8" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" right @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.flag_name" title="Flag">
            <b-dropdown-item @click="vFilter('All Flags',0)">All Flags</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Volume > 60 m³',1)">Volume > 60 m³</b-dropdown-item>
            <b-dropdown-item @click="vFilter('BS&W - 100%',2)">BS&W - 100%</b-dropdown-item>
            <b-dropdown-item @click="vFilter('BS&W < 0.5%',3)">BS&W < 0.5%</b-dropdown-item>
            <b-dropdown-item @click="vFilter('BS&W - Additional Fees Apply',4)">BS&W - Additional Fees Apply</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Haul without Nom',5)">Haul without Nom</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Haul from mobil',17)">Haul from mobil</b-dropdown-item>
            <b-dropdown-item @click="vFilter('With Contracts',6)">With Contracts</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Without Contracts',7)">Without Contracts</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Rerouted: Yes',8)">Rerouted: Yes</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Rerouted: No',9)">Rerouted: No</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Haul Duplicated',10)">Haul Duplicated</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Drive Time:Neg',12)">Drive Time:Neg</b-dropdown-item>
            <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager'" @click="vFilter('Unknow Load Location',0)">Unknow Load Location</b-dropdown-item>
            <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager'" @click="vFilter('Price Anomaly',14)">Price Anomaly</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Duplicated Hauls',15)">Duplicated Hauls</b-dropdown-item>
            <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager'" @click="vFilter('Drive Time Anomaly',16)">Drive Time Anomaly</b-dropdown-item>
            <b-dropdown-item v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" @click="approvedFilter('Approved')">Approved</b-dropdown-item>
            <b-dropdown-item v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" @click="approvedFilter('Unapproved')">Unapproved</b-dropdown-item>
          </b-dropdown>
        </b-col>
      <!--   <b-col v-if="role =='trucking_company_admin' || role =='trucking_operational_manager'" class="my-1 f8" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" right @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="Approved" title="Approved">
            <b-dropdown-item @click="approvedFilter('All')">All</b-dropdown-item>
            <b-dropdown-item @click="approvedFilter('Approved')">Approved</b-dropdown-item>
            <b-dropdown-item @click="approvedFilter('Unapproved')">Unapproved</b-dropdown-item>
          </b-dropdown>
        </b-col>
       v-if="filters_save.flag_name == 'Unknow Load Location' || filters_save.flag_name == 'Price Anomaly' || filters_save.flag_name == 'Duplicated Truck Ticket' || filters_save.flag_name == 'Drive Time Anomaly'" -->
        <b-col class="my-1 f9" title="Initial Date" sm="6" md="4" lg="3">
          <b-form-input id="haul_start_datetime" v-model="filter_by.initial_date" @change="iFilter" type="date" ></b-form-input>
        </b-col>
        <b-col class="my-1 lg-3 f10" title="End date" sm="6" md="4" lg="3">
          <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @change="eFilter" type="date"></b-form-input>
        </b-col>
        
        <b-col class="my-1 lg-3 f11 ml-auto" style=" padding-top: 3px; padding-bottom: 3px;" sm="6" md="4" lg="2">
          <b-button block style="height: 100%;" @click="clearFilters()">Clear</b-button>
        </b-col>


      </b-row>

      <b-row>
        <b-col v-if="haul_ids.length > 0" class="my-1">
          <div class="card bulk-action-controls m-0">
            <div class="card-body p-1 d-flex align-middle">
              <p class="col-sm-3 ml-2 px-0 my-auto align-middle"> {{haul_ids.length}} haul(s) selected of {{totalRows}}</p>
              <b-button v-if="!allSelected" class="col-sm-2 ml-0 btn-select" @click="selectAllHauls"> Select All </b-button>
              <b-dropdown id="ddown1" text="Bulk Actions" class="mx-2 my-auto align-middle" title="Bulk Actions">
                <b-dropdown-item v-if="!this.trash" @click="deleteHaul()">Delete</b-dropdown-item>
                <b-dropdown-item v-else  @click="restoreHauls()">Restore</b-dropdown-item>
                <b-dropdown-item v-if="filters_save.folder == 'All Folders' || filters_save.folder == 'Unassigned Hauls'" @click="openModal()">Add to folder</b-dropdown-item>
                <b-dropdown-item v-else @click="removeHaul()">Remove from folder</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager' || role =='super_admin'" @click="h_approved_click()">Approve Haul</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager' || role =='super_admin'" @click="h_deapproved_click()">Unapprove Haul</b-dropdown-item>
                <b-dropdown-item v-if="(role =='trucking_company_admin' || role =='trucking_operational_manager') && (filters_save.flag_name == 'Unknow Load Location' || filters_save.flag_name == 'Price Anomaly' || filters_save.flag_name == 'Duplicated Hauls' || filters_save.flag_name == 'Drive Time Anomaly')" @click="ignore_click(filters_save.flag_name)">Ignore</b-dropdown-item>
              </b-dropdown>
              <span class="align-middle ml-auto close-controls" @click="unselectAllHauls"> × </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Main table block -->
    <div class="card">
      <div class="card-body p-0">
        <!-- Shows when loading data-->
        <b-row v-if="loadingData">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
          </b-col>
        </b-row>
        <div class="table-responsive p-0 m-0">
          <b-table 
            v-model="tableValues" 
            v-if="!loadingData && filters_save.flag_name == 'All Flags' && FromDash!='Waittimes'" 
            class="animated fadeIn" 
            striped 
            hover 
            show-empty 
            stacked="md" 
            :items="items" 
            :fields="fields" 
            :current-page="currentPage" 
            :per-page="perPage" 
            :filter="filter" 
            :sort-by.sync="filters_save.sortby" 
            :sort-desc.sync="filters_save.sortdesc" 
            @sort-changed="sortingChanged" 
            @filtered="onFiltered" 
            @row-clicked="rowClicked" 
            @refreshed="haulUpdated">
            <template slot="HEAD_select_haul" slot-scope="data">
              <b-form-checkbox
                id="checkbox"
                @click.native.stop
                v-model="allSelected" 
                @change="toggleAllSelected"
              ></b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}} 
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'Volume > 60 m³' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}} 
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'BS&W - 100%' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'BS&W < 0.5%' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'BS&W - Additional Fees Apply' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && (filters_save.flag_name == 'Haul without Nom' || filters_save.flag_name == 'Haul from mobil') && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && FromDash=='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="v_items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked" >
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'With Contracts' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>

          <b-table v-if="!loadingData && filters_save.flag_name == 'Without Contracts' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>

          <b-table v-if="!loadingData && filters_save.flag_name == 'Rerouted: Yes' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>

          <b-table v-if="!loadingData && filters_save.flag_name == 'Rerouted: No' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'Haul Duplicated' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'Drive Time:Neg' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="(role =='trucking_company_admin' || role =='trucking_operational_manager') && !loadingData && (filters_save.flag_name == 'Unknow Load Location' || filters_save.flag_name =='Price Anomaly' || filters_save.flag_name == 'Duplicated Hauls' || filters_save.flag_name =='Drive Time Anomaly') && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="(role !=='trucking_company_admin' || role !=='trucking_operational_manager') && !loadingData && (filters_save.flag_name == 'Duplicated Hauls' || filters_save.flag_name =='Drive Time Anomaly') && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
           <b-table @refreshed="haulUpdated" v-if="(role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager') && !loadingData && (filters_save.flag_name == 'Approved' || filters_save.flag_name =='Unapproved') && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
        </div>
        <!-- Info modal -->
        <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
          <pre>{{ modalInfo.content }}</pre>
        </b-modal>
        <!-- Edit Modal-->
        <b-modal id="modalEdit" ref="mEdit" @hide="resetEditModal" :title="modalEdit.title" ok-only ok-title="Cancel" ok-variant="secundary">
          <b-row>
            <b-col cols="12">
              <b-input-group class="mb-3">
                <div class="input-group-prepend"><span class="input-group-text"><i class="icon-fire"></i></span></div>
                <input type="text" v-model="companyName" class="form-control" placeholder="Company name">
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-button variant="primary" @click="updateEC" class="px-4 pull-right">Update</b-button>
            </b-col>
          </b-row>
        </b-modal>
        <!-- User Interface controls -->
        <div class="table-controls">
          <b-row>
            <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
              <div class="input-group mb-3">
                <div class="input-group-prepend"> </div>
                <b-select :options="pageOptions" v-model="perPage" />
              </div>
            </b-col>
            <b-col lg="10" md="10" sm="12" class="my-1">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mt-0 mb-3 pull-right" />
            </b-col>
          </b-row>
        </div>
        <!-- End User Interface controls-->
      </div>
    </div>
    <!-- New Energy Company Modal-->
    <b-modal class="newHaulModal" ref="newHaulModal" title="New Haul" v-model="newEC" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
          <b-form-group v-if="role =='super_admin' || role ==='operations_manager' || role ==='super_analyst' || role ==='analyst' || this.role =='marketing_accountant'" :label-cols="4" horizontal label="Truking Company" label-for="truck_company">
            <b-form-select id="truck_company_id" v-model="newHaul.truck_company_id" :options="newHaul.truck_company_select" @input="selects_trucking_company()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Trailer" label-for="truck">
            <b-form-select :disabled="newHaul.truck_select.length==0" id="truck_id" v-model="newHaul.truck_id" :options="newHaul.truck_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Truck Unit" label-for="truck_unit">
            <b-form-select :disabled="newHaul.truck_unit_select.length==0" id="truck_unit" v-model="newHaul.truck_unit_id" :options="newHaul.truck_unit_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Driver" label-for="full_name">
            <b-form-select :disabled="newHaul.driver_select.length==0" id="user_id" v-model="newHaul.user_id" :options="newHaul.driver_select" @input="selects_driver()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Energy Company" label-for="energy_company">
            <b-form-select :disabled="newHaul.energy_company_select.length==0" id="energy_companies_id" v-model="newHaul.energy_companies_id" :options="newHaul.energy_company_select" @input="selects_energy_company()" />
          </b-form-group>

          <b-form-group :label-cols="4" horizontal label="Load" label-for="load_location">
            <b-form-select :disabled="newHaul.load_location_select.length==0" id="load_location_id" v-model="newHaul.load_location_id" :options="newHaul.load_location_select" @input="selects_load_location()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Fluid" label-for="fluid_type">
            <b-form-select :disabled="newHaul.fluid_type_select.length==0" id="fluid_type_id" v-model="newHaul.fluid_type_id" :options="newHaul.fluid_type_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Unload" label-for="unload_location">
            <b-form-select :disabled="newHaul.unload_location_select.length==0" id="unload_location_id" v-model="newHaul.unload_location_id" :options="newHaul.unload_location_select" @input="selects_unload_location()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Water Cut Actual %" label-for="water_percentage_actual">
            <b-form-input id="water_percentage_actual" placeholder="0.00" v-model="newHaul.water_percentage_actual" type="text" @blur.native="inputBlur('water_percentage_actual')" @keydown.native="myOnlyNumber($event, 'water_percentage_actual')"></b-form-input>
          </b-form-group>
      <!--     <b-form-group :label-cols="4" horizontal label="Water Cut Estimate" label-for="water_percentage_estimate">
            <b-form-input id="water_percentage_estimate" placeholder="0.00" v-model="newHaul.water_percentage_estimate" @keydown.native="myOnlyNumber($event, 'water_percentage_estimate')" @blur.native="inputBlur('water_percentage_estimate')" type="text"></b-form-input>
          </b-form-group> Terminal Boss Number:-->
          <b-form-group :label-cols="4" horizontal label="Volume Actual" label-for="volume_actual">
            <b-form-input id="volume_actual" placeholder="0.00" v-model="newHaul.volume_actual" @keydown.native="myOnlyNumber($event, 'volume_actual')" @blur.native="inputBlur('volume_actual')" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Volume Estimate" label-for="volume_estimate">
            <b-form-input id="volume_estimate" placeholder="0.00" v-model="newHaul.volume_estimate" @keydown.native="myOnlyNumber($event, 'volume_estimate')" @blur.native="inputBlur('volume_estimate')" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="# Ticket" label-for="ticket">
            <b-form-input id="ticket" v-model="newHaul.ticket"  type="text" @keydown.native=keyMonitor($event) autocomplete="off" placeholder="max 10 characters"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Terminal Ticket" label-for="t_ticket">
            <b-form-input id="t_ticket" v-model="newHaul.t_ticket"  type="text" @keydown.native=keyMonitor1($event) autocomplete="off" placeholder="max 10 characters"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Terminal Boss Number" label-for="t_boss">
            <b-form-input id="t_boss" v-model="newHaul.t_boss"  type="text" v-mask="'##########'" autocomplete="off" placeholder="max 10 digits"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Chain Up" label-for="chain_up">
            <b-form-select  id="chain_up" v-model="newHaul.chain_up"><option :value='false'>NO</option><option :value='true'>YES</option></b-form-select>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Start Date" label-for="haul_start_date">
            <b-form-input id="haul_start_datetime" v-model="newHaul.haul_start_datetime" type="date" ></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Start Time" label-for="haul_start_time">
            <b-form-input id="haul_start_time" placeholder="hh:mm" v-mask="'##:##'" @blur.native="timeBlur('haul_start_time')" v-model="newHaul.haul_start_time" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="End Date" label-for="haul_start_date">
            <b-form-input id="haul_end_datetime" v-model="newHaul.haul_end_datetime" type="date"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="End Time" label-for="haul_end_time">
            <b-form-input id="haul_end_time" placeholder="hh:mm" v-mask="'##:##'" @blur.native="timeBlur('haul_end_time')" v-model="newHaul.haul_end_time" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Comments Start" label-for="comments_start">
            <b-form-input id="comments_start" v-model="newHaul.comments_start" type="text"></b-form-input>
          </b-form-group>
     <!--     <b-form-group :label-cols="4" horizontal label="Comments End" label-for="comments_end">
            <b-form-input id="comments_end" v-model="newHaul.comments_end" type="text"></b-form-input>
          </b-form-group> -->

          <b-form-group v-for="(wait_time, index) in newHaul.wait_times" :key="wait_time.type_id" :label-cols="4" horizontal :label="waitTimeLabel(wait_time)" :label-for="waitTimeLabel(wait_time)">
            <b-form-input placeholder="hh:mm" v-mask="'##:##'" v-model="wait_time.time" type="text"></b-form-input>
            <!-- <b-form-input placeholder="hh:mm" v-mask="'##:##'" v-model="wait_time.time" @blur.native="waitTimeBlur(index)" type="text"></b-form-input> -->
            <b-form-input placeholder="Comments" v-model="wait_time.comments" type="text"></b-form-input>
            <b-btn v-if="wait_time.type_id == 5" size="md" variant="secondary" @click="removeTimeBlur(index)" class="wait-time-remove-button">X</b-btn>
          </b-form-group>

          <b-btn size="md" variant="primary" @click="addWaitTime" class="float-right">Add another Wait Time</b-btn>

        </b-col>
      </b-row>
      <b-row>
				<b-col cols="12">
          <b-form-group :label-cols="4" horizontal label="Hazard Assessment" label-for="hz">
           
          </b-form-group>
				</b-col>
			</b-row>
			<b-row style="padding: 5px 0 0 5px">
				<b-col cols="12">
					<span v-if="newHaul.load_location_id!=''">Load Location: {{ newHaul.load_location_name}}</span>
          <p v-else>No load location selected</p>
				</b-col>
			</b-row>

      <b-row  v-if="newHaul.load_location_id!=''" style="padding: 15px 0 0 15px">
				<b-col v-if="hazards.length>0" cols="12">
					<b-form-group  :label-cols="1" id="L6" label="Hazards:" label-for="hzID" vertical>
						<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="hazards" name="Checkboxes2" plain v-model="hazard_id"  @input="HZChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="hzAllSelected" :indeterminate="indeterminateHZ" aria-describedby="" aria-controls="" plain @change="HZToggleAll">
							{{ hzAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>						
				</b-col>
				<b-col v-else cols="12">
					<p >No Hazards have been added</p>
				</b-col>
			</b-row>

      <b-row  v-if="newHaul.load_location_id!=''" style="padding: 15px 0 0 15px">
				<b-col v-if="controls.length>0" cols="12">
					<b-form-group  :label-cols="1" id="L6" label="Controls:" label-for="ctlID" vertical>
						<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="controls" name="Checkboxes2" plain v-model="control_id"  @input="CTLChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="ctlAllSelected" :indeterminate="indeterminateCTL" aria-describedby="" aria-controls="" plain @change="CTLToggleAll">
							{{ ctlAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>						
				</b-col>
				<b-col v-else cols="12">
					<p >No controls have been added</p>
				</b-col>
			</b-row>

      <b-row style="padding: 5px 0 0 5px">
				<b-col cols="12">
					<span v-if="newHaul.unload_location_id!=''">Unload Location: {{ newHaul.unload_location_name}}</span>
          <p v-else>No unload location selected</p>
				</b-col>
			</b-row>

      <b-row v-if="newHaul.unload_location_id!=''"  style="padding: 15px 0 0 15px">
				<b-col v-if="hazards.length>0" cols="12" >
					<b-form-group  :label-cols="1" id="L6" label="Hazards:" label-for="hzID" vertical>
						<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="hazards" name="Checkboxes2" plain v-model="hazard1_id"  @input="HZ1Change"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="hz1AllSelected" :indeterminate="indeterminateHZ1" aria-describedby="" aria-controls="" plain @change="HZ1ToggleAll">
							{{ hz1AllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>						
				</b-col>
				<b-col v-else  cols="12">
					<p >No Hazards have been added</p>
				</b-col>
			</b-row>

      <b-row  v-if="newHaul.unload_location_id!=''" style="padding: 15px 0 0 15px">
				<b-col v-if="controls.length>0" cols="12">
					<b-form-group  :label-cols="1" id="L6" label="Controls:" label-for="ctlID" vertical>
						<b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="controls" name="Checkboxes2" plain v-model="control1_id"  @input="CTL1Change"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="ctl1AllSelected" :indeterminate="indeterminateCTL1" aria-describedby="" aria-controls="" plain @change="CTL1ToggleAll">
							{{ ctl1AllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>						
				</b-col>
				<b-col v-else cols="12">
					<p >No controls have been added</p>
				</b-col>
			</b-row>

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewHaulModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveHaul" class="float-right">Save</b-btn>
      </div>
    </b-modal>
    <!-- End New Energy Company Modal-->

    <!-- Configure Columns to Display -->
    <b-modal title="Columns to Display" v-model="configTable" ok-variant="primary">

      <b-container class="bv-example-row">
        <b-row>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
                            <b-form-checkbox :disabled="shouldBeDisabled('ticket')" value="ticket" @change="actionField('ticket', 'Ticket #',1)">Ticket #</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('haul_id')" value="haul_id" @change="actionField('haul_id', 'Haul ID', 2)">Haul ID</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('full_name')" value="full_name" @change="actionField('full_name', 'Driver', 5)">Driver</b-form-checkbox>
              <b-form-checkbox v-if="role =='super_admin' || role =='trucking_company_admin' || role =='operations_manager' || role =='trucking_operational_manager'" :disabled="shouldBeDisabled('energy_company')" value="energy_company" @change="actionField('energy_company', 'Energy Company', 3)">Energy Company</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('load_location')" value="load_location" @change="actionField('load_location', 'Load', 6)">Load</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('unload_location')" value="unload_location" @change="actionField('unload_location', 'Unload', 7)">Unload</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('trailer')" value="trailer" @change="actionField('trailer','Trailer',8)">Trailer</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('volume_actual')" value="volume_actual" @change="actionField('volume_actual','Deliveries',9)">Deliveries</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('oil_actual')" value="oil_actual" @change="actionField('oil_actual','Oil',10)">Oil</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('water_actual')" value="water_actual" @change="actionField('water_actual', 'Water',11)">Water</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('bsw')" value="bsw" @change="actionField('bsw', 'BS&W', 12)">BS&W</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('haul_start_date')" value="haul_start_date" @change="actionField('haul_start_date', 'Start Date', 13)">Start Date</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('haul_end_date')" value="haul_end_date" @change="actionField('haul_end_date', 'End Date', 14)">End Date</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('duration')" value="duration" @change="actionField('duration', 'Duration',9)">Duration</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('rate')" value="rate" @change="actionField('rate','Rate', 10)">Rate</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('stb')" value="stb" @change="actionField('stb', 'STB', 11)">STB</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('stb_rate')" value="stb_rate" @change="actionField('stb_rate','STB Rate', 12)">STB Rate</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('unit_cost')" value="unit_cost" @change="actionField('unit_cost','Unit Cost',13)">Unit Cost</b-form-checkbox> -->
              <b-form-checkbox :disabled="shouldBeDisabled('fluid_type')" value="fluid_type" @change="actionField('fluid_type','Fluid Type', 15)">Fluid Type</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('total_distance')" value="total_distance" @change="actionField('total_distance','Distance', 15)">Distance</b-form-checkbox> -->

             <!-- <b-form-checkbox :disabled="shouldBeDisabled('total')" value="total" @change="actionField('total','Total', 16)">Total</b-form-checkbox> -->
              <b-form-checkbox :disabled="shouldBeDisabled('trucking_company')" value="trucking_company" @change="actionField('trucking_company','Trucking Company', 4)">Trucking Company</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('water_percentage_actual')" value="water_percentage_actual" @change="actionField('water_percentage_actual','Water Cut Actual', 16)">Water Cut Actual</b-form-checkbox>
               <!--<b-form-checkbox :disabled="shouldBeDisabled('water_cut_estimate')" value="water_cut_estimate" @change="actionField('water_cut_estimate','Water Cut Estimate', 19)">Water Cut Estimate</b-form-checkbox> -->

              <b-form-checkbox :disabled="shouldBeDisabled('haul_start_time')" value="haul_start_time" @change="actionField('haul_start_time','Start Time', 17)">Start Time</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('haul_end_time')" value="haul_end_time" @change="actionField('haul_end_time','End Time', 18)">End Time</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('driving_time')" value="driving_time" @change="actionField('driving_time','Driving Time', 22)">Driving Time</b-form-checkbox> -->
              <b-form-checkbox :disabled="shouldBeDisabled('avg_speed')" value="avg_speed" @change="actionField('avg_speed','Speed Avg', 19)">Speed Avg</b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">         
              <b-form-checkbox :disabled="shouldBeDisabled('cost_regular')" value="cost_regular" @change="actionField('cost_regular','Regular Cost', 20)">Regular Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('cost_stb')" value="cost_stb" @change="actionField('cost_stb','STB Cost', 21)">STB Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('cost_worktime')" value="cost_worktime" @change="actionField('cost_worktime','Worktime Cost', 22)">Worktime Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('total_cost')" value="total_cost" @change="actionField('total_cost','Total Cost', 23)">Total Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('flags')" value="flags" @change="actionField('flags','Flags', 24)">Flags</b-form-checkbox>
              <b-form-checkbox v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" :disabled="shouldBeDisabled('approved/unapproved')" value="approved/unapproved" @change="actionField('approved/unapproved','Approved/Unapproved Haul', 25)">Approved/Unapproved Haul</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('truck_unit')" value="truck_unit" @change="actionField('truck_unit','Truck Unit',26)">Truck Unit</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('terminal_boss')" value="terminal_boss" @change="actionField('terminal_boss', 'Terminal Boss Ticket',27)">Terminal Boss Ticket</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('volume_estimate')" value="volume_estimate" @change="actionField('volume_estimate','Volume Estimate',28)">Volume Estimate</b-form-checkbox>
					    <b-form-checkbox :disabled="shouldBeDisabled('rate')" value="rate" @change="actionField('rate','Rate', 29)">Rate</b-form-checkbox> 			  
					    <b-form-checkbox :disabled="shouldBeDisabled('stb')" value="stb" @change="actionField('stb', 'STB Time', 30)">STB Time</b-form-checkbox>		  
					    <b-form-checkbox :disabled="shouldBeDisabled('justification')" value="justification" @change="actionField('justification','Justification', 31)">Justification</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('fluid_subtotal_cost')" value="fluid_subtotal_cost" @change="actionField('fluid_subtotal_cost','Fluid Subtotal Cost', 32)">Fluid Subtotal Cost</b-form-checkbox>                                 
					    <b-form-checkbox :disabled="shouldBeDisabled('fluid_gst')" value="fluid_gst" @change="actionField('fluid_gst','Fluid GST', 33)">Fluid GST</b-form-checkbox>                                 
					    <b-form-checkbox :disabled="shouldBeDisabled('fluid_gst_subtotal')" value="fluid_gst_subtotal" @change="actionField('fluid_gst_subtotal','Fluid Total', 34)">Fluid Total</b-form-checkbox> 

					    <b-form-checkbox :disabled="shouldBeDisabled('wait_time_cost_subtotal')" value="wait_time_cost_subtotal" @change="actionField('wait_time_cost_subtotal','Wait Time Cost Subtotal', 34)">Wait Time Cost Subtotal</b-form-checkbox>                                 
					    <b-form-checkbox :disabled="shouldBeDisabled('wait_time_gst')" value="wait_time_gst" @change="actionField('wait_time_gst','Wait Time GST', 35)">Wait Time GST</b-form-checkbox>                                 
					    <b-form-checkbox :disabled="shouldBeDisabled('wait_time_gst_subtotal')" value="wait_time_gst_subtotal" @change="actionField('wait_time_gst_subtotal','Wait Time GST Subtotal', 36)">Wait Time GST Subtotal</b-form-checkbox> 
            </b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-container>
      <!-- </b-form-checkbox-group> -->

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="configTable=false">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="saveSelectedColumns()">
          Save
        </b-btn>
      </div>

    </b-modal>

    <b-modal title="Add to Folders" v-model="modalFolders" ok-variant="primary" hide-header-close no-close-on-backdrop no-close-on-esc>

      <b-container class="bv-example-row">
        <b-row>
          <b-col md="12">
            <b-form-group  :label-cols="2" id="L4"  label-for="folderID" horizontal>
              <b-form-radio-group class="custom-checkboxes" :options="folderOptions" name="Checkboxes" plain v-model="selected"></b-form-radio-group>
              </b-form-group>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="modalFolders=false">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="addHaulsFolder()">
          Save
        </b-btn>
      </div>

    </b-modal>
    <!-- Configure Columns to Display-->

  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import haul_service from './haul_service'
  import moment from 'moment';
  import users_service from '../users/users_service'
  import rowDetails from './rowDetails'

  Vue.use(VueSweetalert2)
  
  const items = []
  export default {
    name: 'hauls',
    components:{
      'row-details' : rowDetails
    },
    created: function() {
      this.Switch_Filters()
      //this.getFilters()
      localStorage.removeItem("haulsaPage");
      localStorage.removeItem("locationsaPage");
      localStorage.removeItem("tagetsaPage");
      localStorage.removeItem("targetPage");
      localStorage.removeItem("taPage");
      localStorage.removeItem("tpPage");
      localStorage.removeItem("oasaPage");
      localStorage.removeItem("oaPage");
      localStorage.removeItem("reportPage");
      localStorage.removeItem("rolesPage");
      localStorage.removeItem("servicePage");
      localStorage.removeItem("tasaPage");
      localStorage.removeItem("tcPage");
      localStorage.removeItem("locationPage");
      localStorage.removeItem("truckPage");
      localStorage.removeItem("userPage");
      if (!localStorage.haulPage) {
          localStorage.haulPage = 0;
      }
      this.$root.$on('haulUpdated', () => {
      this.haul_updated = true;
      this.getAll(parseInt(localStorage.haulPage));
      });
      this.$root.$on('closePopup', () => {
      this.selected_haul_detail = null;
      });

    },
    data() {
      return {
        haul_updated: false,
        selected_haul_detail: null,
        filename : 'report_'+moment().format('YYYYMMDDHHMM')+'.csv',
        json_fields: {
          "haul_id"             :"haul_id",
          "load_location"       :"load_location",
          "load_location_lsd"   :"load_location_lsd",
          "unload_location"     :"unload_location",
          "unload_location_lsd" :"unload_location_lsd",
          "trailer"             :"trailer",
          "truck_unit"          :"truck_unit",
          "full_name"           :"full_name",
          "ticket"              :"ticket",
          "oil_actual"          :"oil_actual",
          "volume_actual"       :"volume_actual",
          "volume_estimate"     :"volume_estimate",
          "water_actual"        :"water_actual",
          "bsw"                 :"bsw",
          "energy_company"      :"energy_company",
          "fluid_type"          :"fluid_type",
          "haul_start_date"     :"haul_start_date",
          "haul_end_date"       :"haul_end_date",
          "water_cut_actual"    :"water_cut_actual",
          "trucking_company"    :"trucking_company",
          "haul_start_time"     :"haul_start_time",
          "haul_end_time"       :"haul_end_time",
          "avg_speed"           :"avg_speed",
          "cost_regular"        :"cost_regular",
          "cost_stb"            :"cost_stb",
          "cost_worktime"            :"cost_worktime",
          "total_cost"          :"total_cost",
          "comments_start"       :"comments_start",
          "comments_end"         :"comments_end",
          "wait_to_load"        :"wait_to_load",
          "comment_wait_to_load":"comment_wait_to_load",
          "wait_to_unload"      :"wait_to_unload",
          "comment_wait_to_unload":"comment_wait_to_unload",
          "other_wait_time"     :"other_wait_time",
          "comment_other_wait_time" :"comment_other_wait_time",
          "personal_time"           :"personal_time",
          "comment_personal_time"   :"comment_personal_time",
          "operating_areas"         : "operating_areas",
          "nomination"              : "nomination",
          "truck_types"             : "truck_types",
       },
        exp_csv: [
          "haul_id",
          "load_location",
          "load_location_lsd",
          "unload_location",
          "unload_location_lsd",
          "trailer",
          'truck_unit',
          "full_name",
          "ticket",
          "oil_actual",
          "volume_actual",
          "volume_estimate",
          "water_actual",
          "bsw",
          "energy_company",
          "fluid_type",
          "haul_start_date",
          "haul_end_date",
          "water_cut_actual",
          "trucking_company",
          "haul_start_time",
          "haul_end_time",
          "avg_speed",
          "cost_regular",
          "cost_stb",
          "cost_worktime",
          "total_cost",
          "comments_start",
          "comments_end",
          "wait_to_load",
          "comment_wait_to_load",
          "wait_to_unload",
          "comment_wait_to_unload",
          "other_wait_time",
          "comment_other_wait_time",
          "personal_time",
          "comment_personal_time",
          "operating_areas",
          "nomination",
          "truck_types",
       ],
       json_data: [],
       json_meta: [
           [
               {
                   'key'  : 'charset',
                   'value': 'utf-8'
               }
           ]
       ],
        newHaul: {
          water_actual              : "",
          water_percentage_estimate : "",
          oil_actual                : "",
          truck_company_select      : [],
          driver_select             : [],
          energy_company_select     : [],
          unload_location_select    : [],
          fluid_type_select         : [],
          load_location_select      : [],
          loads_locations           : [],
          truck_select              : [],
          truck_unit_select         : [],

          companyName               : '',
          load_location             : '',
          loadingData               : true,
          unload_location           : '',
          haul_start_date           : '',

          truck_company_id          : '',
          load_location_id          : '',
          user_id                   : '',
          full_name                 : '',
          truck_id                  : '',
          truck_unit_id             : '',
          trucking_company_id       : '',
          energy_companies_id       : '',
          unload_location_id        : '',
          fluid_type_id             : '',
          water_percentage_actual   : '',
          water_percentage_estimate : '',
          volume_actual             : '',
          volume_estimate           : '',

          haul_end_datetime         : '',
          haul_start_datetime       : '',
          haul_end_time             : '',
          haul_start_time           : '',
          chain_up                  : false,

          comments_start            : '',
          comments_end              : '',
          wait_times_csv            : [],
          wait_times                : [{
            "type_id": "3",
            "time": "00:00",
            "comments": ""
          },
          {
            "type_id": "4",
            "time": "00:00",
            "comments": ""
          },
          ],
          load_location_name        : '',
          unload_location_name      : '',
          ticket                    : '',
          t_ticket                  : '',
          t_boss                    : '',
        },
        allSelected                 : false,
        tableValues                 : [],
        status                      :'unchecked',
        insert_data                 : { 'trucking_companies':[]},
        haul_ids                    : [],
        haul_iidds                  : [],
        haul_iiddss                  : [],
        selected                    : '',
        folderOptions               : [],
        foldersHauls                : [],

        energy_companies_filter     : '',
        folders                     : '',
        load_locations_filter       : '',
        unload_locations_filter     : '',
        drivers_filter              : '',
        trucks_filter               :'',
        trucking_companies_filter   :'',
        fluid_types_filter          :'',
        row: 0,
        loadingData: true,
        trash: false,
        dpdt: "Active",
        filter_by:{"initial_date": moment().startOf('week').format('YYYY-MM-DD'), "end_date": moment().endOf('week').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id":"", "fluid_type_id":"","flags":"",
        "column":[
          'ticket',
          'load_location',
          'unload_location',
          'volume_actual',
          'oil_actual',
          'water_actual',
          'bsw',
          'haul_start_date',
          'haul_start_time',
        ]},
        companyName: '',
        companyId: null,
        newEC: false,
        configTable: false,
        modalFolders: false,

        items: items,
        itemsAll: items,
        items_csv: [],
        totalRows: items.length,
        v_items:null,
        fieldsSelected: 8,
        maxFieldsSelected: 24,
        tempFields: [],
        fields: [
          {
          key: 'select_haul',
          label: 'Select',
          thClass: 'select_column', tdClass: 'select_column'
        }, {
          key: 'ticket',
          label: 'Ticket #',
          sortable: true
        },
        {
          key: 'load_location',
          label: 'Load',
          sortable: true
        }, {
          key: 'unload_location',
          label: 'Unload',
          sortable: true
        }, {
          key: 'volume_actual',
          label: 'Deliveries',
          sortable: true,
          formatter: (value) => { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
        }, {
          key: 'oil_actual',
          label: 'Oil',
          sortable: true,
          formatter: (value) => { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
          // formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+this.unit }
        }, {
          key: 'water_actual',
          label: 'Water',
          sortable: true,
          formatter: (value) => { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
          
          }, {
          key: 'bsw',
          label: 'BS&W (%)',
          sortable: true,
          }, {
          key: 'haul_start_date',
          label: 'Start Date',
          sortable: true,
          formatter:(value) => { return moment(value).format("MMM DD, YYYY") }
        }, {
          key: 'haul_start_time',
          label: 'Start Time',
          sortable: true
        }],
        currentPage               : parseInt(localStorage.haulPage),
        perPage                   : 25,

        pageOptions               : [25, 50, 100],
        filter                    : null,
        modalInfo                 : {
          title: '',
          content: ''
        },
        modalEdit                 : {
          title: ''
        },
        selectedItems             : [
          'load_location',
          'unload_location',
          'volume_actual',
          'oil_actual',
          'water_actual',
          'bsw',
          'haul_start_date',
          'haul_start_time',
        ],
				role                      :'',
				savebtn                   :true,
				energy_company_id         :null,
        unit                      :'',
        dash                      :'',
        FromDash                  :'NoWaittimes',
        fromHaul                  :0,
        filters_save              : {
          folder_id               : 0,
          folder                  : 'All Folders',
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          fluid_type_id           : 0,
          fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All Unloads',
          initial_date            : '',
          end_date                : '',
          flag_name               : 'All Flags',
          sortby                  : 'haul_id',
          sortdesc                : false
        },
        filters_start             : {
          folder_id               : 0,
          folder                  : 'All Folders',
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          fluid_type_id           : 0,
          fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All Unloads',
          initial_date            : '',
          end_date                : '',
          flag_name               : 'All Flags',
          sortby                  : 'haul_id',
          sortdesc                : false
        },
        bbll                      :false,
        h_approved                :false,
        myToggle                  :false,
        activated                 :false,
        Approved                  : 'Show Approved',
        progress                  : false,
        load_csv                  : 'Loading CSV......',
        iscsv                     : false,
        csv                       : '',
				hazards						        : [],
				controls					        : [],
				hazard_id					        : [],
				control_id					      : [],
				indeterminateHZ				    : false,
				hzAllSelected				      : false, 
				indeterminateCTL   			  : false,
				ctlAllSelected				    : false, 
				hazard1_id					      : [],
				control1_id					      : [],
				indeterminateHZ1			    : false,
				hz1AllSelected				    : false, 
				indeterminateCTL1  			  : false,
				ctl1AllSelected				    : false,  
        drivers_temp              : [],
      }
    },
    watch: {
      selected_haul_detail (a, b) {
        let item  = this.tableValues.find(obj => { return obj.haul_id === b} )
            if (item) {
             item._rowVariant  = '';
           }
           item  = this.tableValues.find(obj => { return obj.haul_id === a} )
            if (item) {
             item._rowVariant  = 'selected2';
           }
         let tmp = this.haul_ids
          this.haul_ids = []
          this.haul_ids.push({haul_id: a})
          this.haul_ids = tmp
      },
      haul_ids(a, b) {
        
          this.allSelected = (this.tableValues.length > 0 && this.tableValues.length === a.length) ? true : false;
          b.map(haul_id => {
           let item  = this.tableValues.find(obj => { return obj.haul_id === haul_id} )
            if (item && item.haul_id != this.selected_haul_detail) {
             item._rowVariant  = '';
           }
          return item})
           a.map(haul_id => {
           let item  = this.tableValues.find(obj => { return obj.haul_id === haul_id} )
            if (item && item.haul_id != this.selected_haul_detail) {
             item._rowVariant  = 'selected';
           }
          return item})
      },
      perPage(a, b) {
          if (a !== b) {
            this.currentPage = 1
            //if (!this.h_approved) {
             // this.haul_ids = []
            //}
          }
      },
      currentPage(a, b) {
          if (a !== b) {
             console.log('currentPage')
            //if (!this.h_approved) {
            //  this.haul_ids = []
            //}
          }
      },
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
      haulUpdated () {
        if (this.haul_updated === true)
        this.currentPage = parseInt(localStorage.haulPage)
        this.haul_updated = false
      },
      selectAllHauls() {
        if (!this.allSelected) {
          this.toggleAllSelected();
        }
      },
      unselectAllHauls() {
        if (this.haul_ids.length>0 ) {
          //if (!this.h_approved) {
              this.haul_ids = []
          //} else {
              let tmp1 = this.tableValues.map(item => {
                   return item.haul_id})
              let tmp = this.haul_ids
              let tmp2 = this.array_diff(tmp, tmp1) 
              this.haul_ids = tmp2
          //}
        }
      },
      toggleAllSelected() {
        this.allSelected = !this.allSelected
        if (this.allSelected) {
          //if (!this.h_approved) {
           // this.haul_ids = []
            //this.haul_ids = this.tableValues.map(item => {
             //      return item.haul_id})
         // } else {
            let tmp = this.tableValues.map(item => {
                   return item.haul_id})
            let tmp1 = this.haul_ids
            tmp1.push.apply(tmp1,tmp)
            this.haul_ids = [...new Set(tmp1)]
          //}
        }
        else {
          //if (!this.h_approved) {
            //  this.haul_ids = []
          //} else {
              let tmp1 = this.tableValues.map(item => {
                   return item.haul_id})
              let tmp = this.haul_ids
              let tmp2 = this.array_diff(tmp, tmp1) 
              this.haul_ids = tmp2
          //}
        }
      },
      array_diff(tmp, tmp1) {
	      return tmp.filter(elemento => tmp1.indexOf(elemento) == -1)
      },
      openCreateFolder() {
        localStorage.setItem('folderTo', '01')
        this.$router.push('/folders')
      },
      addHaulsFolder() {

        this.foldersHauls=[]
        this.haul_ids.map(item => {
          var item_data          = {}
          item_data['folder_id'] = this.selected
          item_data['haul_id']   = item
          this.foldersHauls.push(item_data)
        })
        haul_service.addHaulsFolder(this.foldersHauls)
          .then((data) => {
                if (data.status == 'success') {
                  Vue.swal(data.status, data.message, data.status)
                  this.haul_ids =[]
                  this.selected =''
                    this.modalFolders = false
                    this.getAll()
                    this.loadingData = true
                  }else{
                    this.selected =''
                    Vue.swal(data.status, data.message, data.status)
                    this.modalFolders = false
                    // this.getAll()
                    // this.loadingData = true

                  }
              })
      },
      // addFolder() {
      //   console.log(this.haul_ids)
      // },
      openModal() {
        this.folderOptions =[]
        this.folders.map(item => {
          var item_data          = {}
          item_data['value']     = item.id
          item_data['text']      = item.name
          this.folderOptions.push(item_data)
        })
        this.modalFolders = true

      },
      removeHaul() {
        Vue.swal({
          title: 'Please, confirm',
          text: "Are you sure to remove this Hauls?",
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            haul_service.remove(this.haul_ids,this.filter_by['folder_id'])
              .then(data => {
                Vue.swal(data[0], data[1], data[0])
                  this.filter = ''
                  // this.trash = 2
                  this.getAll()
                  this.loadingData = true
              })
              .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
              })
          }
        })
      },
      deleteHaul() {
        Vue.swal({
          title: 'Please, confirm',
          text: "Are you sure to delete this Hauls?",
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            haul_service.delete(this.haul_ids)
              .then(data => {
                Vue.swal(data[0], data[1], data[0])
                  this.filter = ''
                  // this.trash = 2
                  this.getAll()
                  this.loadingData = true
              })
              .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
              })
          }
        })
      },
      restoreHauls() {
        Vue.swal({
          title: 'Please, confirm',
          text: "Are you sure to restore this Hauls?",
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            haul_service.restore(this.haul_ids)
              .then(data => {
                Vue.swal(data[0], data[1], data[0])
                  this.filter = ''
                  // this.trash = 1
                  this.getAll()
                  this.loadingData = true
              })
              .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
              })
          }
        })
      },
      checkedField(row) {
        if (this.haul_ids.includes(row.item.haul_id) ) {
          let index = this.haul_ids.indexOf(row.item.haul_id);
           if (index > -1) {
             this.haul_ids.splice(index, 1);
           }
        }else{
          this.haul_ids.push(row.item.haul_id)

        }
      },
      activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
      },
      deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
      },
      bbl() {
        users_service.bbl()
          .then((data) => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.loadingData = true
                      this.getAll()
                }
              })
          })
      },
      rowClicked(row, index, e) {
        e.preventDefault()
        localStorage.haulPage = this.currentPage;
        if(!this.trash) {
          //this.$router.push('/haul/'+row.haul_id+'/')
          this.selected_haul_detail = row.haul_id
          let to_popup = {'id':row.haul_id,'haul_invoice':false, 'edit':''}
          this.$root.$emit('openPopup', to_popup);
        } else {
          this.restoreHaul(row.haul_id)
        }
      },
      addWaitTime() {
        this.newHaul.wait_times.push({
          "type_id": "5",
          "time": "00:00",
          "comments": ""
        })
      },
      hmsToSecondsOnly(str) {
        var p = str.split(':'),
          s = 0,
          m = 1;

        while (p.length > 0) {
          s += m * parseInt(p.pop(), 10);
          m *= 60;
        }
        s *= 60
        return s;
      },
      waitTimeLabel(wait_time) {
        let wait_times_label = [{
            type_id: "3",
            label: "Wait Time To Load"
          },
    /*      {
            type_id: "1",
            label: "Loading Time"
          },  */
          {
            type_id: "4",
            label: "Wait Time To Unload"
          },
     /*     {
            type_id: "2",
            label: "Unloading Time"
          }, */
        ]
        let myIndex = wait_times_label.map(o => o.type_id).indexOf(wait_time.type_id)
        if (myIndex > -1) {
          return wait_times_label[myIndex].label
        }
        return "Other Wait Time"
      },
      hideNewHaulModal() {
        this.$refs.newHaulModal.hide()
      },
      showNewHaulModal() {
        this.savebtn=false
            this.newHaul.truck_company_select = []
            this.newHaul.driver_select = []
            this.newHaul.energy_company_select = []
            this.newHaul.unload_location_select = []
            this.newHaul.fluid_type_select = []
            this.newHaul.load_location_select = []
            this.newHaul.truck_select = []

            this.newHaul.truck_company_id = ''
            this.newHaul.load_location_id = ''
            this.newHaul.user_id = ''
            this.newHaul.full_name = ''
            this.newHaul.truck_id = ''
            this.newHaul.truck_unit_id = ''
            this.newHaul.energy_companies_id = ''
            this.newHaul.unload_location_id = ''
            this.newHaul.fluid_type_id = ''

            this.newHaul.comments_start = ''
            this.newHaul.comments_end = ''

            this.water_percentage_actual = ''
            this.water_percentage_estimate = ''
            this.volume_actual = ''
            this.volume_estimate = ''
            let tempDate = new Date()
            let tempDateTime = String(tempDate.getFullYear()) + "-" + ("0" + String(tempDate.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempDate.getDate())).slice(-2)
            let tempTime = ("0" + String(tempDate.getHours())).slice(-2) + ":" + ("0" + String(tempDate.getMinutes())).slice(-2)

            this.newHaul.haul_end_datetime = '' // tempDateTime
            this.newHaul.haul_start_datetime = '' //tempDateTime
            this.newHaul.haul_end_time = tempTime
            this.newHaul.haul_start_time = tempTime
            this.newHaul.chain_up = false
            //this.newHaul.ticket = ''
            this.newHaul.t_ticket = ''
            this.newHaul.t_boss = ''
            // hazard assessment
            this.newHaul.load_location_name = ''
            this.newHaul.unload_location_name = ''
				    this.hazard_id					        = []
				    this.control_id					        = []
				    this.indeterminateHZ				    = false
				    this.hzAllSelected				      = false 
				    this.indeterminateCTL   			  = false
				    this.ctlAllSelected				      = false 
				    this.hazard1_id					        = []
				    this.control1_id					      = []
				    this.indeterminateHZ1			      = false
				    this.hz1AllSelected				      = false 
				    this.indeterminateCTL1  			  = false
				    this.ctl1AllSelected				    = false 
            
        if (this.role =='super_admin') {
          if (this.insert_data.trucking_companies.length > 0) {  
            let trucking_companies = this.insert_data.trucking_companies
            this.newHaul.truck_company_select = trucking_companies.map((item) => {
              return {
                'value': item.id,
                'text': item.name
              }
            })
          } else {
              this.get_trucking_companies()
          }
        } else if  (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
            if (this.insert_data.trucking_companies.length > 0) {  
              this.selects_trucking_company()
            } else {
              this.get_trucking_companies()
              this.selects_trucking_company()
            } 
                        
        }
        this.newEC = true
      },
      okToSave() {
        if (this.newHaul.energy_companies_id === undefined || this.newHaul.energy_companies_id.length == 0) {
          this.$swal('Alert!', 'Energy Company not selected', 'warning')
          return false
        } else if (this.newHaul.fluid_type_id === undefined || this.newHaul.fluid_type_id.length == 0) {
          this.$swal('Alert!', 'Fluid Type not selected', 'warning')
          return false
        } else if (this.newHaul.load_location_id === undefined || this.newHaul.load_location_id.length == 0) {
          this.$swal('Alert!', 'Load Location not selected', 'warning')
          return false
        } else if (this.newHaul.truck_company_id === undefined || this.newHaul.truck_company_id.length == 0) {
          this.$swal('Alert!', 'Truck Company not selected', 'warning')
          return false
        } else if (this.newHaul.unload_location_id === undefined || this.newHaul.unload_location_id.length == 0) {
          this.$swal('Alert!', 'Unload Location not selected', 'warning')
          return false
        } else if (this.newHaul.user_id === undefined || this.newHaul.user_id.length == 0) {
          this.$swal('Alert!', 'Driver not selected', 'warning')
          return false
        } else if (this.newHaul.truck_id === undefined || this.newHaul.truck_id.length == 0) {
          this.$swal('Alert!', 'Trailer not selected', 'warning')
          return false
        } else if (this.newHaul.volume_actual === undefined || this.newHaul.volume_actual.length == 0) {
          this.$swal('Alert!', 'Volume Actual can not be empty', 'warning')
          return false
        } else if (this.newHaul.volume_actual <5) {
          this.$swal('Alert!', 'Volume Actual value must have at least five(5) ', 'warning')
          return false
        } else if (this.newHaul.volume_estimate === undefined || this.newHaul.volume_estimate.length == 0) {
          this.$swal('Alert!', 'Volume Estimate can not be empty', 'warning')
          return false 
        } else if (this.newHaul.ticket === undefined || this.newHaul.ticket.length == 0) {
          this.$swal('Alert!', 'Ticket can not be empty', 'warning')
          return false
        } else if (!this.Check_one_numbers(this.newHaul.ticket)) {
          this.$swal('Alert!', 'Ticket must have at least on number', 'warning')
          return false
        }

        try {
          let startDateValidation = (new Date(this.newHaul.haul_start_datetime)).getFullYear()
          if(startDateValidation <= 2000 || startDateValidation >= 2100) {
            throw ''
          }
        } catch (error) {
          this.$swal('Alert!', 'Start Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning')
          return false
        }

        try {
          let endDateValidation = (new Date(this.newHaul.haul_end_datetime)).getFullYear()
          if(endDateValidation <= 2000 || endDateValidation >= 2100) {
            throw ''
          }
        } catch (error) {
          this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning')
          return false
        }

        return true
      },
      waitTimeBlur(myIndex) {
        try {
          let variableValue = this.newHaul.wait_times[myIndex].time
          if (variableValue.length == 0) {
            this.newHaul.wait_times[myIndex].time = "00:00"
          } else {
            let tempValue = variableValue.split(":")
            if (tempValue.length == 1) {
              this.newHaul.wait_times[myIndex].time = String(Math.min(variableValue, 24)) + ":00"
            } else if (tempValue.length == 2) {
              let min1 = String(Math.min(tempValue[0], 24))
              let min2 = String(Math.min(tempValue[1], 59))
							this.newHaul.wait_times[myIndex].time = ("0" + min1).slice(-2) + ":" + (min2 + "0").slice(-2)
              // this.newHaul.wait_times[myIndex].time = (String(Math.min(tempValue[0], 24)) + "00").slice(0, 2) + ":" + (String(Math.min(tempValue[1], 59)) + "00").slice(0, 2)
            }
          }
        } catch (error) {
        }
      },
      removeTimeBlur(myIndex) {
        try {
          this.newHaul.wait_times.splice(myIndex, 1)
        } catch (error) {
        }
      },
      timeBlur(variableName) {
        let variableValue = this.newHaul[variableName]
        if (variableValue.length == 0) {
          this.newHaul[variableName] = "00:00"
        } else {
          let tempValue = variableValue.split(":")
          if (tempValue.length == 1) {
            let min = String(Math.min(tempValue[0], 24))
            this.newHaul[variableName] = ("0" + min).slice(-2) + ":00"
          } else if (tempValue.length == 2) {
            let min1 = String(Math.min(tempValue[0], 24))
            let min2 = String(Math.min(tempValue[1], 59))
            this.newHaul[variableName] = ("0" + min1).slice(-2) + ":" + ("0" + min2).slice(-2)
          }
        }
      },
      inputBlur(variableName) {
        let variableValue = this.newHaul[variableName]
        if (variableValue.length == 0) {
          this.newHaul[variableName] = "0.00"
        } else {
          let tempValue = variableValue.split(".")
          if (tempValue.length == 1) {
            this.newHaul[variableName] = String(variableValue) + ".00"
          } else if (tempValue.length == 2) {
            this.newHaul[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
          }
        }
      },
      myOnlyNumber(evt, variableName) {
        let dotPosition = this.newHaul[variableName].indexOf(".")
        let hasDot = dotPosition > -1
        let length = this.newHaul[variableName].length
        this.isNumber(evt, hasDot, dotPosition, length)
      },
      isNumber: function(evt, hasDot, dotPosition, length) {

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
          let selectionStart = evt.target.selectionStart;
          let selectionEnd = evt.target.selectionEnd;
          if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
            evt.preventDefault();
          } else {
            return true
          }
        } else {
          evt.preventDefault();
        }
      },
      selects_trucking_company() {
        if (this.role =='super_admin') {
          this.newHaul.user_id = ''
          this.newHaul.full_name = ''
          this.newHaul.truck_id = ''
          this.newHaul.truck = ''
          this.newHaul.truck_unit_id = ''
          this.newHaul.truck_unit = ''
          let trucking_companies = this.insert_data.trucking_companies

          let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.newHaul.truck_company_id)
          if (current_truck_company_index > -1) {
            let drivers = trucking_companies[current_truck_company_index]['drivers']
            this.newHaul.driver_select = drivers.map((item) => {
              return {
                'value': item.id,
                'text': item.name
              }
            })
            let trucks = trucking_companies[current_truck_company_index]['trucks']
            this.newHaul.truck_select = trucks.map((item) => {
             return {
                'value': item.id,
                'text': item.truck_name
              }
            })
            let truck_units = trucking_companies[current_truck_company_index]['truck_units']
            this.newHaul.truck_unit_select = truck_units.map((item) => {
             return {
                'value': item.id,
                'text': item.truck_unit
              }
            })
            // SAME as in APP - Select if there is only one item in the array
            if (this.newHaul.driver_select.length == 1) {
              this.newHaul.full_name = this.newHaul.driver_select[0].text
              this.newHaul.user_id = this.newHaul.driver_select[0].value
            }
            if (this.newHaul.truck_select.length == 1) {
              this.newHaul.truck = this.newHaul.truck_select[0].text
              this.newHaul.truck_id = this.newHaul.truck_select[0].value
            }
            if (this.newHaul.truck_unit_select.length == 1) {
              this.newHaul.truck_unit = this.newHaul.truck_select[0].text
              this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value
            }
          }
        } else if  (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {

                this.newHaul.user_id = ''
                this.newHaul.full_name = ''
                this.newHaul.truck_id = ''
                this.newHaul.truck = ''
                this.newHaul.truck_unit_id = ''
                if (this.insert_data.trucking_companies.length>0) {
                  let trucking_companies = this.insert_data.trucking_companies
                  this.newHaul.truck_company_id = trucking_companies[0].id
                  let drivers = trucking_companies[0]['drivers']
                  this.newHaul.driver_select = drivers.map((item) => {
                    return {
                    'value': item.id,
                    'text': item.name
                    }
                  })
                  let trucks = trucking_companies[0]['trucks']
                  this.newHaul.truck_select = trucks.map((item) => {
                    return {
                    'value': item.id,
                    'text': item.truck_name
                    }
                  })
                  let truck_units = trucking_companies[0]['truck_units']
                  this.newHaul.truck_unit_select = truck_units.map((item) => {
                    return {
                    'value': item.id,
                    'text': item.truck_unit
                    }
                  })
                  // SAME as in APP - Select if there is only one item in the array
                  if (this.newHaul.driver_select.length == 1) {
                    this.newHaul.full_name = this.newHaul.driver_select[0].text
                    this.newHaul.user_id = this.newHaul.driver_select[0].value
                  }
                  if (this.newHaul.truck_select.length == 1) {
                    this.newHaul.truck = this.newHaul.truck_select[0].text
                    this.newHaul.truck_id = this.newHaul.truck_select[0].value
                  }
                  if (this.newHaul.truck_unit_select.length == 1) {
                    this.newHaul.truck_unit = this.newHaul.truck_select[0].text
                    this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value
                  }
                }
        }
      },
      selects_energy_company() {
        this.newHaul.load_location_select = []
        this.newHaul.load_location = ''
        this.newHaul.load_location_id = ''
        let trucking_companies = this.insert_data.trucking_companies

        let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.newHaul.truck_company_id)
        if (current_truck_company_index > -1) {
          let drivers = trucking_companies[current_truck_company_index]['drivers']
          let drivers_index = drivers.map(o => o.id).indexOf(this.newHaul.user_id)
          if (drivers_index > -1) {
            let energycompanies = drivers[drivers_index]['energy_companies']
            let energy_company_index = energycompanies.map(o => o.id).indexOf(this.newHaul.energy_companies_id)
            this.getLoadLocation (energycompanies[energy_company_index].id, drivers[drivers_index].id)
          }
        }
      },
      getLoadLocation (energy_company_id,driver_id) {
        haul_service.getLoadLocation(energy_company_id,driver_id)
          .then(data => {
                if (data['status'] == 'success') {
                  this.loads_locations = data['load_locations']
                   this.newHaul.load_location_select = this.loads_locations.map((item) => {
                     return {
                       'value': item.id,
                       'text': item.legal_location
                     }
                   })
                   if (this.newHaul.load_location_select.length == 1) {
                       this.newHaul.load_location = this.newHaul.load_location_select[0].text
                       this.newHaul.load_location_id = this.newHaul.load_location_select[0].value
                     }
                } else {
                  this.$swal(data[0], data[1], data[0])
                }
                this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      selects_driver() {
        // alert()
        this.newHaul.energy_companies_id = ''
        this.newHaul.energy_company = ''
        this.newHaul.unload_location_select = []
        this.newHaul.unload_location = ''
        this.newHaul.unload_location_id = ''

        let trucking_companies = this.insert_data.trucking_companies
        let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.newHaul.truck_company_id)
        if (current_truck_company_index > -1) {
          let drivers = trucking_companies[current_truck_company_index]['drivers']
          let drivers_index = drivers.map(o => o.id).indexOf(this.newHaul.user_id)
          let energycompanies = drivers[drivers_index]['energy_companies']
          this.newHaul.energy_company_select = energycompanies.map((item) => {
            return {
              'value': item.id,
              'text': item.company_name
            }
          })
          this.getUnloadLocation (drivers[drivers_index].id)
        }
      },
      getUnloadLocation (driver_id) {
        haul_service.getUnloadLocation(driver_id)
          .then(data => {
                if (data['status'] == 'success') {
                  let loads_locations = data['unload_locations']
                    this.newHaul.unload_location_select = loads_locations.map((item) => {
                      return {
                        'value': item.id,
                        'text': item.legal_location
                      }
                    })
                } else {
                  this.$swal(data[0], data[1], data[0])
                }
                this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      selects_load_location() {

        this.newHaul.fluid_type_select = []
        this.newHaul.fluid_type = ''
        this.newHaul.fluid_type_id = ''
        let loads_locations = this.loads_locations
        let loads_locations_index = loads_locations.map(o => o.id).indexOf(this.newHaul.load_location_id)
        if (loads_locations_index > -1) {
          let fluid_types = loads_locations[loads_locations_index]['fluids']
          this.newHaul.load_location_name = loads_locations[loads_locations_index].legal_location
          this.newHaul.fluid_type_select = fluid_types.map((item) => {
            return {
              'value': item.id,
              'text': item.name
            }
          })
        }
      },

      openSelectColumns() {
        this.tempFields = [...this.fields]
        this.configTable = true
      },
      saveSelectedColumns() {
        this.fields = [...this.tempFields]
        this.filter_by.column = this.fields.map(item =>  item.key )
        this.configTable = false
        haul_service.saveSelectedColumns(this.fields)
          .then((data) => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.getAll()
                  setTimeout(
                    () => {
                      this.$refs.mEdit.hide()
                    }, 500)
                }
              }) 
          })
      },
      shouldBeDisabled(option) {
        return (this.fieldsSelected >= this.maxFieldsSelected) && this.tempFields.map(o => o.key).indexOf(option) == -1
      },
      actionField(option, label, position) {
        var fieldsLength = this.tempFields.length
        var fieldIsActive = false
        for (var i = 0; i <= fieldsLength; i++) {
          fieldIsActive = true
          try {
            if (this.tempFields[i].key === option || this.tempFields[i] === option) {
              this.tempFields.splice(i, 1)
              fieldIsActive = false
              break
            }
          } catch (err) {

            if (option=='haul_start_date' || option=='haul_end_date') {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
              }
            } else if (option=='oil_actual' || option=='volume_actual' || option=='volume_estimate' || option=='water_actual') {
                      option = {
                        key: option,
                        label: label,
                        sortable: true,
                        formatter: (value) =>  { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
                      }
            } else {
                option = {
                  key: option,
                  label: label,
                  sortable: true
                }
            }
            this.tempFields.splice(position, 0, option)
          }
        }
        this.fieldsSelected = this.tempFields.length
      },
      info(item, index, button) {
        this.modalInfo.title = `Row: ${index + 1}`
        this.modalInfo.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', 'modalInfo', button)
      },
      resetModal() {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
      },
      resetEditModal() {
        this.modalEdit.title = ''
        this.companyName = ''
      },
      onFiltered(filteredItems) {
        //if (!this.h_approved) {
         // this.haul_ids = []
        //}
        
        this.currentPage = parseInt(localStorage.haulPage)
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        if (this.haul_updated !== true)
        this.currentPage = 1
      },
      saveHaul() {
        this.inputBlur('water_percentage_actual')
        this.inputBlur('water_percentage_estimate')
        this.inputBlur('volume_actual')
        this.inputBlur('volume_estimate')
        if (!this.okToSave()) {
          return
        }
        this.savebtn=true
        let tempStartDateTime = new Date((this.newHaul.haul_start_datetime + " " + this.newHaul.haul_start_time).replace(/-/g, "/"))
        let tempEndDateTime = new Date((this.newHaul.haul_end_datetime + " " + this.newHaul.haul_end_time).replace(/-/g, "/"))

        let haul_start_datetime = String(tempStartDateTime.getFullYear()) + "-" + ("0" + String(tempStartDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempStartDateTime.getDate())).slice(-2) + " " + tempStartDateTime.toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false
        });
        let haul_end_datetime = String(tempEndDateTime.getFullYear()) + "-" + ("0" + String(tempEndDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempEndDateTime.getDate())).slice(-2) + " " + tempEndDateTime.toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false
        });

        let saveData = {
          "energy_companies_id": String(this.newHaul.energy_companies_id),
          "users_id": String(this.newHaul.user_id),
          "fluid_type_id": String(this.newHaul.fluid_type_id),
          "load_location_id": String(this.newHaul.load_location_id),
          "unload_location_id": String(this.newHaul.unload_location_id),
          "truck_id": String(this.newHaul.truck_id),
          "trucks_unit_id": String(this.newHaul.truck_unit_id),
          "haul_start_datetime": haul_start_datetime,
          "haul_end_datetime": haul_end_datetime,
          "volume_estimate": String(this.newHaul.volume_estimate),
          "volume_actual": String(this.newHaul.volume_actual),
          "water_percentage_estimate": String(this.newHaul.water_percentage_estimate),
          "water_percentage_actual": String(this.newHaul.water_percentage_actual),
          "terminal_ticket": String(this.newHaul.t_ticket),
          "truck_ticket": String(this.newHaul.ticket),
          "terminal_boss_ticket_id": String(this.newHaul.t_boss),
          "chain_up_required": this.newHaul.chain_up,
          "total_distance": "0",
          "comments_start": String(this.newHaul.comments_start),
          "comments_end": String(this.newHaul.comments_end),
          "waypoints": "",
          "trip_pictures": "",
          "wait_times": this.newHaul.wait_times.map((item) => {
            return { ...item,
              time: this.hmsToSecondsOnly(item.time)
            }
          }),
          "hazard_id"				   : this.hazard_id,
					"control_id"			   : this.control_id,
					"hazard1_id"			   : this.hazard1_id,
					"control1_id"			   : this.control1_id,
        }
        haul_service.save(saveData)
          .then(data => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.companyName = ''
                  this.newEC = false
                  this.getAll()
                }
              })
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
          })
          this.savebtn=false
      },
      trashHaul() {
        this.trash = !this.trash
        this.dpdt = this.trash ? "Trash" : "Active"
        this.getAll()
        this.loadingData = true
      },

      clearFilters() {
        this.filter_by = {"initial_date": moment().startOf('week').format('YYYY-MM-DD'), 
        "end_date": moment().endOf('week').format('YYYY-MM-DD'), 
        "truck_id": "", 
        "trucking_company_id":"", 
        "users_id": "", 
        "unload_location_id": "", 
        "energy_companies_id": "", 
        "load_location_id": "", 
        "folder_id":"",
        "fluid_type_id":"",
        "flags":"",
        "column":[
          'ticket',
          'load_location',
          'unload_location',
          'volume_actual',
          'oil_actual',
          'water_actual',
          'bsw',
          'haul_start_date',
          'haul_start_time',
        ]}
        this.filters_save = {
          folder_id             : 0,
          folder                : 'All Folders',
          energy_companies_id   : 0,
          energy_company_name   : 'All Energy Companies',
          users_id              : 0,
          driver_name           : 'All Drivers',
          fluid_type_id         : 0,
          fluid_type_name       : 'All Fluid Types',
          trucking_company_id   : 0,
          trucking_company_name : 'All Trucking Companies',
          truck_id              : 0,
          truck_name            : 'All Trucks',
          load_location_id      : 0,
          load_name             : 'All Loads',
          unload_location_id    : 0,
          unload_name           : 'All Unloads',
          initial_date          : '', // moment().startOf('month').format('YYYY-MM-DD'),
          end_date              : '', //moment().endOf('month').format('YYYY-MM-DD'),
          flag_name             : 'All Flags',
          sortby                : 'haul_id',
          sortdesc              : false
        }
        this.FromDash='NoWaittimes'
        this.Approved = 'Show Approved'
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },

      Folders(folder,id) {
        this.filter_by['folder_id'] = id

        if (id==0 && folder == 'All Folders') {
          this.filter_by['folder_id'] = ''
        }
        if (id==0 && folder == 'Unassigned Hauls') {
          this.filter_by['folder_id'] = id
        }
        this.filters_save.folder =  folder
        this.filters_save.folder_id = id
        this.saveFilters()
        this.getAll()
        this.loadingData = true

      },
      ecFilter(ec_filter,id) {
        this.filter_by['energy_companies_id'] = id

        if (id==0) {
          this.filter_by['energy_companies_id'] = ''
        }
        this.filters_save.energy_company_name =  ec_filter
        this.filters_save.energy_companies_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true

      },
      ftFilter(ft_filter,id) {
        this.filter_by['fluid_type_id'] = id

        if (id==0) {
          this.filter_by['fluid_type_id'] = ''
        }
        this.filters_save.fluid_type_name =  ft_filter
        this.filters_save.fluid_type_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true

      },
      dFilter(d_filter,id) {
        this.filter_by['users_id'] = id
        if (id==0) {
          this.filter_by['users_id'] = ''
        }
        this.filters_save.driver_name =  d_filter
        this.filters_save.users_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      tFilter(t_filter,id) {
        this.filter_by['truck_id'] = id
        if (id==0) {
          this.filter_by['truck_id'] = ''
        }
        this.filters_save.truck_name =  t_filter
        this.filters_save.truck_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      tcFilter(tc_filter,id) {
        this.filter_by['trucking_company_id'] = id
        if (id==0) {
          this.filter_by['trucking_company_id'] = ''
        }
        this.filters_save.trucking_company_name =  tc_filter
        this.filters_save.trucking_company_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      ttFilter(tt_filter,id) {
        this.filter_by['truck_type_id'] = id
        if (id==0) {
          this.filter_by['truck_type_id'] = ''
        }
        this.getAll()
        this.loadingData = true
      },
      lFilter(l_filter,id) {
        this.filter_by['load_location_id'] = id
        if (id==0) {
          this.filter_by['load_location_id'] = ''
        }
        this.filters_save.load_name =  l_filter
        this.filters_save.load_location_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      uFilter(u_filter,id) {
        this.filter_by['unload_location_id'] = id
        if (id==0) {
          this.filter_by['unload_location_id'] = ''
        }
        this.filters_save.unload_name =  u_filter
        this.filters_save.unload_location_id = id
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      vFilter(v_filter,id) {
        this.filter_by['flags'] = id
        this.filters_save.flag_name =  v_filter
        this.Approved = 'Show Approved'
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      iFilter(a) {
        if (this.filter_by['end_date']=='' || !this.filter_by['end_date']) {
          this.filter_by['end_date'] = ''
          this.filters_save.end_date = ''
        }
        this.filter_by.initial_date = a
        this.filters_save.initial_date = this.filter_by.initial_date
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      eFilter(a) {
        if (this.filter_by['initial_date'] =='' || !this.filter_by['initial_date']) {
          this.filter_by['initial_date'] = ''
          this.filters_save.initial_date = ''
        }
        this.filter_by.end_date = a
        this.filters_save.end_date = this.filter_by.end_date
        this.getAll()
        this.saveFilters()
        this.loadingData = true
      },
      getAll() {
        
        //this.haul_ids = []
        this.items = []
        this.v_items = []
        this.activated = false
        haul_service.getAll(this.filter_by)
          .then(data => {
            if (data.status == 'success') {
              this.items      = data.hauls.filter(o => o.status_id == (this.trash ? 2 : 1))            
              this.itemsAll   = this.items 
              this.haul_iidds = data.haul_approved_ids
              this.haul_iiddss = data.haul_unapproved_ids
              this.drivers_temp = data.drivers
              if (this.Approved=='Approved' || this.Approved=='Unapproved') {
                this.approvedFilter(this.Approved)
              }
              this.getAll1()
              this.activated = true
              this.export_to_csv()
              this.$refs.excel
            }
            else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      reformat(value) {
        if (value.indexOf('%')!= -1) {
            return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" %"
        } else if (value.indexOf('km')!= -1) {
            return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" km"
        } else {
            return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        }
      },
      editEC(item, button) {
        this.modalEdit.title = `Editing ID: ${item.id}`
        this.companyName = item.name
        this.companyId = item.id
        this.$root.$emit('bv::show::modal', 'modalEdit', button)
      },
      updateEC() {
        if (this.companyName.trim() && this.companyId) {
          haul_service.update(this.companyId, this.companyName)
            .then((data) => {
              Vue.swal(data[0], data[1], data[0])
                .then((result) => {
                  if (data[0] == 'success') {
                    this.companyName = ''
                    this.getAll()
                    setTimeout(
                      () => {
                        this.$refs.mEdit.hide()
                      }, 500)
                  }
                })
            })
          Vue.swal('Alert!', 'Company name have not empty', 'warning')
            .catch(error => {
              Vue.swal('Error', 'Server not response. ' + error, 'error')
            })
        } else {}
      },
      restoreHaul(id) {
        Vue.swal({
          title: 'Please, confirm',
          text: "Are you sure to restore this Haul?",
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            haul_service.restore(id)
              .then(data => {
                Vue.swal(data[0], data[1], data[0])
                  this.filter = ''
                  this.trash = 1
                  this.getAll()
                  this.loadingData = true
              })
              .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
              })
          }
        })
      },
      saveFilters() {
        //this.Approved = 'Show Approved'
        this.haul_ids = [] 
        haul_service.saveFilters(0,this.filters_save)
          .then((data) => {
                if (data[0] == 'success') {
                    return
                } else {
                    Vue.swal(data[0], data[1], data[0])
                    return
                }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            return
          })
      },
      getFilters() {
          haul_service.getFilters(0)
            .then((data) => {
                  if (data[0] == 'success') {
                      this.filters_start  = data[1]
                      this.filters_start1 = data[2]
                      if (this.filters_start.length != 0) {
                        // Code Changed and Optimized
                        for (var property in this.filters_start[0]) {
                          this.filters_save[property]   = this.filters_start[0][property]
                          if (this.filters_start[0][property] == 0){
                              this.filter_by[property] = ""
                          } else if (this.filters_start[0][property] == null){
                              this.filter_by[property] = ""
                          } else {
                                this.filter_by[property] = this.filters_start[0][property]
                          }
                        } // for
                        if(this.filters_start[0]['initial_date'] == null)
                        {
                            this.filter_by['initial_date'] = moment().startOf('week').format('YYYY-MM-DD')
                            this.filters_save['initial_date'] = moment().startOf('week').format('YYYY-MM-DD')
                        }
                        if(this.filters_start[0]['end_date'] == null)
                        {
                          this.filter_by['end_date'] = moment().endOf('week').format('YYYY-MM-DD')
                          this.filters_save['end_date'] = moment().endOf('week').format('YYYY-MM-DD')
                        }

                        for (var property in this.filters_start1[0]) {
                          this.filters_save[property]   = this.filters_start1[0][property]
                        } // for

                        if (this.filters_start[0].folder_id == 0 && this.filters_start1[0].folder == 'Unassigned Hauls') {
                          this.filter_by.folder_id = this.filters_start[0].folder_id
                        }
                        this.filters_save.folder_id             = this.filters_start[0].folder_id
                        this.filters_save.folder                = this.filters_start1[0].folder
                        // Select column
                        if ( data[3]!= '') {
                            this.fields = []
                            this.fields = data[3]
                        }
                        if (this.fields.length>0) {
                            this.selectedItems = []
                            for (let i = 0; i < this.fields.length; i++) {
                                let key = this.fields[i].key
                                this.selectedItems.push(key)
                                if (key=='haul_start_date' || key=='haul_end_date') {
                                  this.fields[i].formatter=(value) => { return moment(value).format("MMM DD, YYYY") }
                                }

                                if (key=='oil_actual' || key=='volume_actual' || key=='volume_estimate' || key=='water_actual') {
                                  this.fields[i].formatter= (value) => { if (this.bbll==true){
                                      value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                } else {
                                      value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                }; return value }
                            }
                            }
                        }
                        this.filter_by.column =  this.selectedItems
                        // -------------
                      } else {
                          this.filters_save.folder_id             = 0
                          this.filters_save.folder                = "All Folders"
                          this.filters_save.energy_companies_id   = 0
                          this.filters_save.energy_company_name   = "All Energy Companies"
                          this.filters_save.fluid_type_id         = 0
                          this.filters_save.fluid_type_name       = "All Fluid Types"
                          this.filters_save.users_id              = 0
                          this.filters_save.driver_name           = "All Drivers"
                          this.filters_save.truck_id              = 0
                          this.filters_save.truck_name            = "All Trucks"
                          this.filters_save.trucking_company_id   = 0
                          this.filters_save.trucking_company_name = "All Trucking Companies"
                          this.filters_save.unload_location_id    = 0
                          this.filters_save.load_name             = "All Loads"
                          this.filters_save.unload_location_id    = 0
                          this.filters_save.unload_name           = "All Unloads"
                          this.filters_save.flag_name             = "All Flags"
                          this.filters_save.initial_date          = moment().startOf('week').format('YYYY-MM-DD')
                          this.filters_save.end_date              = moment().endOf('week').format('YYYY-MM-DD')
                          this.filters_save.sortby                = 'haul_id'
                          this.filters_save.sortdesc              = false
                          this.filter_by={"initial_date": moment().startOf('week').format('YYYY-MM-DD'), 
                          "end_date": moment().endOf('week').format('YYYY-MM-DD'), 
                          "truck_id": "",
                          "trucking_company_id":"", 
                          "users_id": "", 
                          "unload_location_id": "", 
                          "energy_companies_id": "", 
                          "load_location_id": "",
                          "folder_id":"",
                          "fluid_type_id":"",
                          "flags":"",
                          "column":[
                            'ticket',
                            'load_location',
                            'unload_location',
                            'volume_actual',
                            'oil_actual',
                            'water_actual',
                            'bsw',
                            'haul_start_date',
                            'haul_start_time',
                          ]}
                      }
                      this.getAll()
                      this.loadingData = true
                  } else {
                      Vue.swal(data[0], data[1], data[0])
                      this.loadingData = false
                  }
            })
            .catch(error => {
              Vue.swal('Error', 'Server not response. ' + error, 'error')
              this.loadingData = false
            })
      },
      sortingChanged (ctx) {
        this.filters_save.sortdesc  = ctx.sortDesc
        this.filters_save.sortby    = ctx.sortBy
        this.saveFilters()
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      },
      Switch_Filters(){
        
        if("dashboard" in localStorage){
          this.dash=localStorage.getItem('dashboard')
        } else {
          this.dash="dash00"
        }
        this.FromDash='NoWaittimes'
        if (this.dash=="dash00"){
            localStorage.setItem('dashboard', 'dash00')
            this.getFilters()
        } else if (this.dash=="dash09") {
            this.filters_save.folder_id             = 0
            this.filters_save.folder                = "All Folders"
            this.filters_save.energy_companies_id   = 0
            this.filters_save.fluid_type_id         = 0
            this.filters_save.fluid_type_name       = "All Fluid Types"
            this.filters_save.users_id              = 0
            this.filters_save.driver_name           = "All Drivers"
            this.filters_save.truck_id              = 0
            this.filters_save.truck_name            = "All Trucks"
            this.filters_save.trucking_company_id   = 0
            this.filters_save.trucking_company_name = "All Trucking Companies"
            this.filters_save.load_location_id    = 0
            this.filters_save.load_name             = "All Loads"
            this.filters_save.unload_location_id    = 0
            this.filters_save.unload_name           = "All Unloads"
            this.filters_save.flag_name             = "All Flags"
            this.filters_save.sortby                = 'haul_id'
            this.filters_save.sortdesc              = false
            this.filter_by={"initial_date": '', "end_date": moment().endOf('week').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "","folder_id":"","fluid_type_id":"","flags":"",
          "column":[
            'ticket',
            'load_location',
            'unload_location',
            'volume_actual',
            'oil_actual',
            'water_actual',
            'bsw',
            'haul_start_date',
            'haul_start_time',
          ]}
              this.filters_save.flag_name     = localStorage.getItem('dashboard_flag_name')
              this.filter_by.flags = parseInt(localStorage.getItem('dashboard_flag_id'))
              localStorage.removeItem('dashboard_flag_name');
              localStorage.removeItem('dashboard_flag_id');
              localStorage.setItem('dashboard', 'dash00')
              this.getAll()
              this.loadingData = true
        } else {
            this.filters_save.folder_id             = 0
            this.filters_save.folder                = "All Folders"
            this.filters_save.energy_companies_id   = 0
            this.filters_save.fluid_type_id         = 0
            this.filters_save.fluid_type_name       = "All Fluid Types"
            this.filters_save.users_id              = 0
            this.filters_save.driver_name           = "All Drivers"
            this.filters_save.truck_id              = 0
            this.filters_save.truck_name            = "All Trucks"
            this.filters_save.trucking_company_id   = 0
            this.filters_save.trucking_company_name = "All Trucking Companies"
            this.filters_save.load_location_id    = 0
            this.filters_save.load_name             = "All Loads"
            this.filters_save.unload_location_id    = 0
            this.filters_save.unload_name           = "All Unloads"
            this.filters_save.flag_name             = "All Flags"
            this.filters_save.sortby                = 'haul_id'
            this.filters_save.sortdesc              = false
            this.filter_by={"initial_date": moment().startOf('week').format('YYYY-MM-DD'), "end_date": moment().endOf('week').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "","folder_id":"","fluid_type_id":"","flags":"",
          "column":[
            'ticket',
            'load_location',
            'unload_location',
            'volume_actual',
            'oil_actual',
            'water_actual',
            'bsw',
            'haul_start_date',
            'haul_start_time',
          ]}

            //this.dash_energy_companies_id            = localStorage.getItem('dashboard_energy_id')
            //this.dash_energy_companies_name          = localStorage.getItem('dashboard_energy_name')
            //this.dash_start_date                     = localStorage.getItem('dashboard_start_date')
            //this.dash_end_date                       = localStorage.getItem('dashboard_end_date')

            this.filter_by.initial_date             = localStorage.getItem('dashboard_start_date')
            this.filter_by.end_date                 = localStorage.getItem('dashboard_end_date')
            this.filter_by.energy_companies_id      = localStorage.getItem('dashboard_energy_id')
            this.filters_save.energy_company_name   = localStorage.getItem('dashboard_energy_name')

            if("dashboard_trucking_company_id" in localStorage){
              if (localStorage.getItem('dashboard_trucking_company_id') != '') {
                this.filters_save.trucking_company_id = localStorage.getItem('dashboard_trucking_company_id')
                this.filter_by.trucking_company_id    = this.filters_save.trucking_company_id
              } else {
                this.filters_save.trucking_company_id = 0
                this.filter_by.trucking_company_id    = ''
              }
            } else {
                this.filters_save.trucking_company_id = 0
                this.filter_by.trucking_company_id    = ''
            }

          if("dashboard_trucking_company_name" in localStorage){
              if (localStorage.getItem('dashboard_trucking_company_name') != '') {
                this.filters_save.trucking_company_name = localStorage.getItem('dashboard_trucking_company_name')
              } else {
                this.filters_save.trucking_company_name = "All Trucking Companies"
              }
            } else {
                this.filters_save.trucking_company_name = "All Trucking Companies"
            }

            if (this.dash=='dash03'){
              this.filters_save.unload_location_id    = localStorage.getItem('dashboard_location_id')
              this.filter_by.unload_location_id       = this.filters_save.unload_location_id
              this.filters_save.unload_name           = localStorage.getItem('dashboard_location_name')
              this.FromDash='Waittimes'
              localStorage.removeItem('dashboard_location_id');
              localStorage.removeItem('dashboard_location_name');
            }

            if (this.dash=='dash04'|| this.dash=='dash06'|| this.dash=='dash07'){
              this.filters_save.unload_location_id    = localStorage.getItem('dashboard_location_id')
              this.filter_by.unload_location_id       = this.filters_save.unload_location_id
              this.filters_save.unload_name           = localStorage.getItem('dashboard_location_name')
              this.filters_save.fluid_type_id         = localStorage.getItem('dashboard_fluid_type_id')
              this.filter_by.fluid_type_id            = this.filters_save.fluid_type_id
              this.filters_save.fluid_type_name       = localStorage.getItem('dashboard_fluid_type_name')

              localStorage.removeItem('dashboard_location_id');
              localStorage.removeItem('dashboard_location_name');
              localStorage.removeItem('dashboard_fluid_type_id');
              localStorage.removeItem('dashboard_fluid_type_name');

            }

            if (this.dash=='dash05'){
              this.filters_save.load_location_id    = localStorage.getItem('dashboard_location_id')
              this.filter_by.load_location_id       = this.filters_save.load_location_id
              this.filters_save.load_name           = localStorage.getItem('dashboard_location_name')
              this.filters_save.fluid_type_id       = localStorage.getItem('dashboard_fluid_type_id')
              this.filter_by.fluid_type_id          = this.filters_save.fluid_type_id
              this.filters_save.fluid_type_name     = localStorage.getItem('dashboard_fluid_type_name')

              localStorage.removeItem('dashboard_location_id');
              localStorage.removeItem('dashboard_location_name');
              localStorage.removeItem('dashboard_fluid_type_id');
              localStorage.removeItem('dashboard_fluid_type_name');

            }

            if (this.dash=='dash08'){
              this.filters_save.flag_name     = localStorage.getItem('dashboard_flag_name')
              this.filter_by.flags = 11
              localStorage.removeItem('dashboard_flag_name');
            }
            if (this.dash=='dash09'){
              this.filters_save.flag_name     = localStorage.getItem('dashboard_flag_name')
              this.filter_by.flags = 11
              localStorage.removeItem('dashboard_flag_name');
            }

            localStorage.setItem('dashboard', 'dash00')
            localStorage.removeItem("dashboard_start_date");
            localStorage.removeItem("dashboard_end_date");
            localStorage.removeItem('dashboard_energy_id');
            localStorage.removeItem('dashboard_energy_name');
            localStorage.removeItem('dashboard_trucking_company_id');
            localStorage.removeItem('dashboard_trucking_company_name');
            this.getAll()
            this.loadingData = true

        }
      },
      getAll1() {

          haul_service.getAll1()
            .then(data => {
              if (data.status == 'success') {
                
                this.energy_companies_filter  = data.energy_companies_filter
                this.folders                  = data.folders
                this.drivers_filter           = data.drivers_filter
                this.load_locations_filter    = data.load_locations_filter
                this.unload_locations_filter  = data.unload_locations_filter
                this.trucks_filter            = data.trucks_filter
                this.truck_types_filter       = data.truck_types_filter
                this.trucking_companies_filter = data.trucking_companies_filter
                this.fluid_types_filter       = data.fluid_types_filter 

                this.bbll       = data.bbl
                this.role       = data.role
                if (this.role =='trucking_company_admin') {
                    this.drivers_filter  = this.drivers_temp
							  }
                this.hazards = data.hazards
                this.controls = data.controls

              }
              else {

                this.$swal(data.status, data.message, data.status)
                this.loadingData = false
                return
              }
              this.loadingData = false
            })
            .catch(error => {
              Vue.swal('Error', 'Server not response. ' + error, 'error')
              this.loadingData = false
            })
      },
      get_trucking_companies() {
          haul_service.get_trucking_hauls()
            .then((data) => {
                  if (data.status  == 'success') {
                      this.insert_data = data.insert_data
                      let trucking_companies = this.insert_data.trucking_companies
                      if (this.role =='super_admin') {
                      
                        this.newHaul.truck_company_select = trucking_companies.map((item) => {
                                return {
                                          'value': item.id,
                                          'text': item.name
                                        }
                        }) 
          
                      }

                      else if  (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
                        if (trucking_companies.length > 0) {
                          this.newHaul.truck_company_id = trucking_companies[0].id

                          let drivers = trucking_companies[0]['drivers']

                          this.newHaul.driver_select = drivers.map((item) => {
                              return {
                                'value': item.id,
                                'text': item.name
                              }
                          })
                          let trucks = trucking_companies[0]['trucks']
                          this.newHaul.truck_select = trucks.map((item) => {
                              return {
                                'value': item.id,
                                'text': item.truck_name
                              }
                          })
                          let truck_units = trucking_companies[0]['truck_units']
                          this.newHaul.truck_unit_select = truck_units.map((item) => {
                          return {
                              'value': item.id,
                              'text': item.truck_unit
                            }
                          })
                          if (this.newHaul.truck_unit_select.length == 1) {
                            this.newHaul.truck_unit = this.newHaul.truck_select[0].text
                            this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value
                          }
                          // SAME as in APP - Select if there is only one item in the array
                          if (this.newHaul.driver_select.length == 1) {
                            this.newHaul.full_name = this.newHaul.driver_select[0].text
                            this.newHaul.user_id = this.newHaul.driver_select[0].value
                          }
                          if (this.newHaul.truck_select.length == 1) {
                            this.newHaul.truck = this.newHaul.truck_select[0].text
                            this.newHaul.truck_id = this.newHaul.truck_select[0].value
                          }
                        }
                  }
                } else {
                      this.$swal(data.status, data.message, data.status)
                }
            })
            .catch(error => {
              this.$swal('Error', 'Server not response. ' + error, 'error')
            })
      },
      export_to_csv(){
          this.items_csv = []
          haul_service.export_to_csv(this.filter_by)
            .then((data) => {
                  if (data.status  == 'success') {
                      this.items_csv = data.hauls
                      console.log(this.items_csv)
                      if (this.items_csv.length!==0) {    
                          this.csv = this.combine_to_csv()
                          if (this.iscvs) {
                            this.progress   = false
                            this.iscvs      = false   
                            this.exportCSVFile(this.csv, this.filename)    
                          }                           
                      } else {
                          if (this.iscvs) {
                            this.progress   = false
                            this.iscvs      = false    
                          }                       
                      }              
                  } else {
                      //this.$swal(data.status, data.message, data.status)
                      this.items_csv = []
                      this.progress = false
                  }
            })
            .catch(error => {
              //this.$swal('Error', 'Server not response. ' + error, 'error')
              this.items_csv = []
              this.progress = false
            }) 
          
      },
      HaulsApproved() {
          haul_service.HaulsApproved(this.haul_ids)
            .then((data) => {
                  if (data.status == 'success') {
                    Vue.swal(data.status, data.message, data.status)
                    //this.haul_ids =[]
                    //this.selected =''
                    this.getAll()
                    this.loadingData = true
                  }else{
                    //this.selected =''
                    Vue.swal(data.status, data.message, data.status)

                  }
                })
        },
      h_approved_change() {
          if (!this.h_approved) {
            this.h_approved = true
            this.haul_ids = this.haul_iidds 
          } else {
            this.h_approved = false
            this.haul_ids = []      
          }
        },

      h_approved_click(){
        let model = {
          command:'approved',
          approved : this.haul_ids
        }
        // this.Approved = 'Show Approved'
        this.haul_ids = []
        haul_service.HaulsApproved(model)
          .then((data) => {
            if (data.status == 'success') {
              Vue.swal(data.status, data.message, data.status)
              this.getAll()
              this.loadingData = true
            }else{
              Vue.swal(data.status, data.message, data.status)

            }
          })
      },
      h_deapproved_click() {
        // this.haul_ids =[]
        let model = {
          command  :'unapproved',
          unapproved : this.haul_ids
        }
        //this.Approved = 'Show Approved'
        //this.filters_save.flag_name ='Show Approved'
        this.haul_ids = []
        haul_service.HaulsApproved(model)
          .then((data) => {
            if (data.status == 'success') {
              Vue.swal(data.status, data.message, data.status)
              this.getAll()
              this.loadingData = true
            }else{
              Vue.swal(data.status, data.message, data.status)

            }
          })
      },
      mergeByProperty(target, source, prop)
      {
        let str = ""
        let line = ""
        this.exp_csv.forEach(element1 => {
            line += element1
            line += ","
        })
        str += line + "\r\n";
        source.forEach(sourceElement => {
          let targetElement = target.find(targetElement => {
            return sourceElement[prop] === targetElement[prop];
          })
          targetElement ? Object.assign(targetElement, sourceElement) : target.push(sourceElement);
          let line = ""
          this.exp_csv.forEach(element1 => {
            if (element1 in targetElement) {
              line += '\"' + targetElement[element1] + '\",'
            }
          })
          str += line + "\r\n"
          })
          return str
      },
      combine_to_csv(){
          let hauls_data  = this.items
          let hauls_csv   = this.items_csv
          let columns     = this.filter_by.column
          return this.mergeByProperty(hauls_csv, hauls_data,'haul_id')
      },
      approvedFilter(apr_filter) {
        if (this.role =='super_admin' || this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
          let itemsO = this.itemsAll
          this.Approved = apr_filter
          if (apr_filter==='Approved') {     
            let result = itemsO.filter(item => {return item.trucking_company_approved ==true})
            this.items = result
            //this.haul_ids = this.haul_iidds 
            this.filters_save.flag_name ='Approved'
          } else if (apr_filter==='Unapproved') {
            let result = itemsO.filter(item => {return item.trucking_company_unapproved ==true})
            this.items = result
            //this.haul_ids = this.haul_iiddss
            this.filters_save.flag_name ='Unapproved'
          } else {
            this.items = this.itemsAll
            this.haul_ids = []
            this.Approved = 'Show Approved'
          }
        }
        },
      ignore_click(flag) {
        if (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
          let model = {
            flag    : flag,
            ignored : this.haul_ids
          }
          this.haul_ids = []
          haul_service.HaulsIgnored(model)
            .then((data) => {
              if (data.status == 'success') {
                Vue.swal(data.status, data.message, data.status)
                this.getAll()
                this.loadingData = true
              }else{
                Vue.swal(data.status, data.message, data.status)
              }
            })        
        }
      }, 
      csv_export() {
        if (this.items_csv.length===0) {
          if (this.items.length!==0) {
            this.progress   = true
            this.iscvs      = true
          }
        } else {
          this.progress   = false
          this.iscvs      = false  
          // this.exportCSVFile(this.json_fields, this.items_csv, this.filename) 
          this.exportCSVFile(this.csv, this.filename)   
        }    
      },
      exportCSVFile(csv, fileName) {

        const exportName = fileName;
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, exportName);
        } else {
          const link = document.createElement("a");
          if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      },
    			// Selecting when pressing Enter
			keyMonitor(evt) {
				if(evt.key.match(/[a-zA-Z0-9]/i)===null) {
						evt.preventDefault()
						return					
				} else {
					evt = (evt) ? evt : window.event;
					let key = evt.key
					if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown")  {
						return
					} else if (key == "Backspace" ) {
						let filter_txt = this.newHaul.ticket
						let nn 				= filter_txt.length - 1
						if (nn>0) {
							this.newHaul.ticket = filter_txt.substring(0, nn)
							return
						} else {
							  this.newHaul.ticket  = ''
							return
						}
						
					} else if (key == "Delete" ) {
						return
					} else {
              
              let filter_txt = this.newHaul.ticket
              let nn 				= filter_txt.length
              if (nn<10) {               
                filter_txt = filter_txt + key
                this.newHaul.ticket = filter_txt
              } else {
                evt.preventDefault()
              }
						  return					
					}
				}
			},
      keyMonitor1(evt) {
				if(evt.key.match(/[a-zA-Z0-9]/i)===null) {
						evt.preventDefault()
						return					
				} else {
					evt = (evt) ? evt : window.event;
					let key = evt.key
					if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown")  {
						return
					} else if (key == "Backspace" ) {
						let filter_txt = this.newHaul.t_ticket
						let nn 				= filter_txt.length - 1
						if (nn>0) {
							this.newHaul.t_ticket = filter_txt.substring(0, nn)
							return
						} else {
							  this.newHaul.t_ticket  = ''
							return
						}
						
					} else if (key == "Delete" ) {
						return
					} else {
              
              let filter_txt = this.newHaul.t_ticket
              let nn 				= filter_txt.length
              if (nn<10) {               
                filter_txt = filter_txt + key
                this.newHaul.t_ticket = filter_txt
              } else {
                evt.preventDefault()
              }
						  return					
					}
				}
			},
      Check_one_numbers(str_in) {
        // Regular expression
        const regex = /\d/
        return regex.test(str_in)
      },
    	HZChange() {
				if (this.hazard_id.length === 0) {
					this.indeterminateHZ = false
					this.hzAllSelected = false
				} else if (this.hazard_id.length === this.hazards.length) {
					this.indeterminateHZ = false
					this.hzAllSelected = true
				} else {
					this.indeterminateHZ = true
					this.hzAllSelected = false
				}
			},
			HZToggleAll(checked) {
				this.hazard_id = checked ? this.hazards.map(item => {
					return item.id
				}) : []
			},
			CTLChange() {
				if (this.control_id.length === 0) {
					this.indeterminateCTL = false
					this.ctlAllSelected = false
				} else if (this.control_id.length === this.controls.length) {
					this.indeterminateCTL = false
					this.ctlAllSelected = true
				} else {
					this.indeterminateCTL = true
					this.ctlAllSelected = false
				}
			},
			CTLToggleAll(checked) {
				this.control_id = checked ? this.controls.map(item => {
					return item.id
				}) : []
			},
			HZ1Change() {
				if (this.hazard1_id.length === 0) {
					this.indeterminateHZ1 = false
					this.hz1AllSelected = false
				} else if (this.hazard1_id.length === this.hazards.length) {
					this.indeterminateHZ1 = false
					this.hz1AllSelected = true
				} else {
					this.indeterminateHZ1 = true
					this.hz1AllSelected = false
				}
			},
			HZ1ToggleAll(checked) {
				this.hazard1_id = checked ? this.hazards.map(item => {
					return item.id
				}) : []
			},
			CTL1Change() {
				if (this.control1_id.length === 0) {
					this.indeterminateCTL1 = false
					this.ctl1AllSelected = false
				} else if (this.control1_id.length === this.controls.length) {
					this.indeterminateCTL1 = false
					this.ctl1AllSelected = true
				} else {
					this.indeterminateCTL1 = true
					this.ctl1AllSelected = false
				}
			},
			CTL1ToggleAll(checked) {
				this.control1_id = checked ? this.controls.map(item => {
					return item.id
				}) : []
			},
      selects_unload_location() {

        let unloads_locations = this.newHaul.unload_location_select
        let unloads_locations_index = unloads_locations.map(o => o.value).indexOf(this.newHaul.unload_location_id)
        if (unloads_locations_index > -1) {
          this.newHaul.unload_location_name = unloads_locations[unloads_locations_index].text
        }
      },
  }
}
</script>

<style lang="scss" scoped>
  .show-details-cell{
    font-weight: 500;
    cursor: pointer;
  }
  .table-controls{
    padding: 14px 16px 0 16px;
  }
  /deep/ .table{
    margin: 0;
    td{
      white-space: nowrap;
      vertical-align: middle;
    }
    th{
      white-space: nowrap;
      vertical-align: middle;
    }
    td> div{
      line-height: 1;
    }
    .b-table-details> td {
      background-color: #FFFDF0;
    }
    .b-table-details h6{
      padding: 0;
      margin: 0;
      font-size: 0.8rem;
      line-height: 16px;
      margin-bottom: 8px;
      color: #676973;
    }
    .b-table-details p{
      font-size: 16px;
      color: #3A3E4D;
      padding: 0;
      margin: 0;
      line-height: 18px;
      margin-bottom: 16px;
    }
    .details-container{
      position: relative;
      white-space: normal; 
      display: flex; 
      flex-direction: row;
      flex-wrap: nowrap; 
      justify-content: flex-start;
      .item{
        padding-left: 10px;
        padding-right: 10px;
      }
      .item.location{
        width: 180px;
      }
      .item.ticket{
        width: 130px;
      }
      .item.date{
        width: 180px;
      }
      .item.volume{
        min-width: 100px;
      }
      &::after{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 20px;
        height: 100%;
        border-top: 1px solid #bcbcbc;
      }
      &::before{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 2px;
        height: 100%;
        border-left: 1px solid #bcbcbc;
      }
    }
    .details-container:last-child::before{
      display: none;
    }
  }
  /deep/ .btn-secondary{
    background: #ffffff;
  }
  /deep/ .custom-control {
    margin: 0;
    padding-left: 1rem;
  }
  /deep/ .select_column{width: 2%}
  /deep/ .bulk-action-controls{
    .dropdown{
      display: block;
      width: 100%;
    }
    .dropdown-toggle{
      display: block;
      width: 100%;
      text-align: left;
    }
    .dropdown-toggle::after {
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -2px;
    }
    .close-controls{
      font-size: 18px; 
      font-weight: bold;
      height: 35px; 
      line-height: 14px;
      cursor: pointer;
      padding: 8px;
    }
    .btn-secondary{
      border-color: #cacaca;
    }
    .btn-select{
      height: 35px;
      margin-bottom: auto;
      margin-top: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/hauls/hauls.vue